import { Injectable, OnDestroy } from '@angular/core';
import { ISport } from '../models/sportHierarchy/sport';
import { IRegion } from '../models/sportHierarchy/region';
import { ICompetition } from '../models/sportHierarchy/competition.iterface';
import { KeyValue } from '@angular/common';
import { IBet } from '../models/bet/bet';
import { EventVM } from '../models/event/event';
import { TimeFilter, SBVSelectionType, EventMappingType, BetOutcomeOddDifference, PageType, BetTypeSelectionSBVSelectionType, TreeLevel, HierarchyType, BetOrderingType, SpecialOfferType, EventType, EventStatus } from '../models/enums';
import { IBetOutcome } from '../models/bet/betOutcome.interface';
import { filter, switchMap, map, publishReplay, tap, switchAll } from 'rxjs/operators';
import { UtilityService } from './util/utility.service';
import { EventsProviderService } from './providers/events.provider.service';
import { IBetTypeGroup } from '../models/betType/betTypeGroup.interface';
import { ModelMapperService } from './util/model.mapper.service';
import { SportsProviderService } from './providers/sports.provider.service';
import { Observable, of, Subscription, Subject, forkJoin, from } from 'rxjs';
import { IEventsList } from '../models/event/eventsList.interface';
import { IEventsGroupComponentViewModel } from '../models/event/eventsGroupComponentViewModel.interface';
import { SettingsService } from './settings.service';
import { IBetTypeGroupingTemplateItem } from '../models/betType/betTypeGroupingTemplateItem.interface';
import { IBetsAndOutcomesForBetTypeGroup } from '../models/bet/betsAndOutcomesForBetTypeGroup.interface';
import { IBetV2TO } from '../models/bet/transportObjects/betV2TO.interface';
import { CacheChangesService } from './cacheChanges.service';
import { ICacheChanges } from '../models/cacheChanges/cacheChanges.interface';
import { ISportRegionCompetitionSelection } from '../models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { ISrcSelectionIds } from '../models/util/srcSelectionIds.interface';
import { IEventLiveResultInfo } from '../models/event/eventLiveResultInfo.interface';
import { IWebEventsDictionaryObjectTO } from '../models/event/transportObjects/webEventsDictionaryObjectTO.interface';
import { IBetTypeShowType } from '../models/betType/betTypeShowType.interface';
import { ConstantValues } from '../models/util/constantValues';
import { IBetTypeSelection } from '../models/betType/betTypeSelection.interface';
import { IBetTO } from '../models/bet/transportObjects/betTO.interface';
import { IBetOutcomeV2TO } from '../models/bet/transportObjects/betOutcomeV2TO.interface';
import { IBetOutcomeTO } from '../models/bet/transportObjects/betOutcomeTO.interface';
import { ISportWithCompetitions } from '../models/sportHierarchy/sportWithCompetitions.interface';
import { QueryParamsService } from './http/queryParams.service';
import { IEventLiveResultInfoTO } from '../models/event/transportObjects/eventLiveResultInfoTO.interface';
import { ISportWithSelectionsTO } from '../models/sportHierarchy/transportObjects/sportWithSelectionsTO.interface';
import { ISportWithSelections } from '../models/sportHierarchy/ISportWithSelections.interface';
import { ICompetitionsAndBetTypeGroupsWithEventOrderNoTO } from '../models/event/transportObjects/competitionsAndBetTypeGroupsWithEventOrderNoTO.interface';
import { IBetTypeGroupsForHierarchy } from '../models/betType/betTypeGroupsForHierarchy.interface';
import { IEventsAndGroupsConfigurationsTO } from '../models/event/transportObjects/eventsAndGroupsConfigurationsTO.intrerface';
import { StorageService } from './util/storage.service';
import { IGroupsForCompetitionsTO } from '../models/event/transportObjects/groupsForCompetitionsTO.interface';
import { ViewConfigurations } from '../models/util/viewConfigurations';
import { IEventSrc } from '../models/event/eventSrc.interface';
import { ISportWithEventsList } from '../models/event/sportWithEventsList.interface';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ITicketItemIdentifier } from '../models/ticket/ticketItemIdentfier.interface';
import { DeployParams } from '../deployParams';
import { ISportForLiveTreeTO } from '../models/sportHierarchy/transportObjects/sportForLiveTreeTO.interface';
import { environment } from 'src/environments/environment';
const pmTreeRefreshTimeSeconds = 60;
@Injectable()
export class CacheService implements OnDestroy {
  private betGroupIdsForLoadedBetsInSport: { [sportId: number]: number[] } = {};
  private betGroupIdsForLoadedBetsInRegion: { [regionId: number]: number[] } = {};
  private betGroupIdsForLoadedBetsInCompetition: { [competitionId: number]: number[] } = {};
  private selectedFilter: TimeFilter;
  private sports: { [id: number]: ISport } = {};
  private regions: { [sportId: number]: { [id: number]: IRegion } } = {};
  private competitions: { [regionId: number]: { [id: number]: ICompetition } } = {};
  private events: { [competition: number]: { [id: number]: EventVM } } = {};
  // private specialOfferEventIds: { [eventMappingTypeId: number]: { [copmetitionId: number]: number[] } } = {};
  private specialOfferSports: { [SpecialOfferType: number]: { [id: number]: IRegion } } = {};
  private bets: { [eventId: number]: { [betTypeId: number]: { [id: number]: IBet } } } = {};
  private betOutcomes: { [betId: number]: { [betTypeOutcomeId: number]: { [id: number]: IBetOutcome } } } = {};
  private isLive = false;
  private loadedEventsType: SpecialOfferType;

  private betTypeGroupsForHierarchy: { [hierarchyType: number]: IBetTypeGroupsForHierarchy } = {};

  private betTypeGroups: { [id: number]: IBetTypeGroup } = {};


  private betTypeSelectionsForSport: { [sportId: number]: IBetTypeSelection[] } = {};
  // will be different untill sports and events are loaded
  private timeFilterForSports: TimeFilter;
  private timeFilterForEvents: TimeFilter;

  private subscription: Subscription = new Subscription();

  private sportTreeChangedSource = new Subject<void>();
  public sportTreeChanged$ = this.sportTreeChangedSource.asObservable();
  private sportTreeElementsWithAddedRemovedEventsChangedSource = new Subject<ISrcSelectionIds[]>();
  public sportTreeElementsWithAddedRemovedEventsChanged$ = this.sportTreeElementsWithAddedRemovedEventsChangedSource.asObservable();
  private betsAndOutcomesAddedRemovedSource = new Subject<number[]>();
  public betsAndOutcomesAddedRemoved$ = this.betsAndOutcomesAddedRemovedSource.asObservable();
  private updatedCacheTimePM = 0;
  private pageType: PageType;
  private mostPopularOrSoonEventAddedRemovedSource = new Subject<number[]>();
  public mostPopularOrSoonEventAddedRemoved$ = this.mostPopularOrSoonEventAddedRemovedSource.asObservable();
  private userEventsForNotifications: number[] = [];
  public favoriteLiveEventsSrc: IEventSrc[] = [];
  public favoriteEventsCount = 0;

  private treeUpdateTime = 60;

  private favoriteListChangedSource = new Subject<number>();
  public favoriteListChanged$ = this.favoriteListChangedSource.asObservable();

  private sportTreeObservable: Observable<ISport[]> = null;


  constructor(
    private settingsService: SettingsService,
    private utilityService: UtilityService,
    private eventsProvider: EventsProviderService,
    private modelMapper: ModelMapperService,
    private sportsProvider: SportsProviderService,
    private storage: StorageService,
    private queryParamService: QueryParamsService,
    private cacheChangesService: CacheChangesService) {
    this.subscription.add(this.cacheChangesService.cacheUpdatedPM$.subscribe(c => {
      if (!this.isLive) {
        this.updateCache(c, !cacheChangesService.isFirstChangesPM);
        this.treeUpdateTime -= ConstantValues.CACHE_INTERVAL_PM_SEC;

        if (this.treeUpdateTime <= 0) {
          this.treeUpdateTime = pmTreeRefreshTimeSeconds;
          const dates = this.utilityService.getDateFromTo(false, this.timeFilterForSports);
          this.getSportsFromServerAndAddToCache(dates.dateFrom, dates.dateTo, this.isLive, true, false).subscribe(x => this.sportTreeChangedSource.next());
        }
      }
    }));
    this.subscription.add(this.cacheChangesService.cacheUpdatedLive$.subscribe(c => {
      if (this.isLive) {
        this.updateCache(c, !cacheChangesService.isFirstChangesLive);
      }
    }));
    this.subscription.add(this.queryParamService.pageTypeChanged$.subscribe((pt) => {
      if (this.pageType !== pt) {
        this.clearEventsData();
        // If we are comming from live or any page that has no time filter on it
        if (this.pageType === PageType.Live) {
          this.timeFilterForEvents = null;
          this.timeFilterForSports = null;
        }
      }
      this.pageType = pt;
      if (this.pageType === PageType.Live) {
        if (!this.isLive) {
          this.resetCache();
        }
        this.isLive = true;
      } else {
        if (this.isLive) {
          this.resetCache();
        }
        this.isLive = false;
      }
    }));
    this.favoriteLiveEventsSrc = this.storage.favoriteLiveEventsSRC;
    this.resetCache();
  }

  public addEventToNotifications(eventId: number) {
    if (!this.userEventsForNotifications.includes(eventId)) {
      this.userEventsForNotifications.push(eventId);
    }
  }

  public removeEventFromNotifications(eventId: number) {
    const index = this.userEventsForNotifications.findIndex(evId => evId === eventId);
    if (index > -1) {
      this.userEventsForNotifications.splice(index, 1);
    }
  }

  addEventTofavorites(eventSRC: IEventSrc) {
    if (!this.events[eventSRC.competitionId] || !this.events[eventSRC.competitionId][eventSRC.eventId]) {
      return;
    }
    if (this.favoriteLiveEventsSrc.findIndex(ev => ev.eventId === eventSRC.eventId) > -1) {
      return;
    }

    this.events[eventSRC.competitionId][eventSRC.eventId].isInFavorite = true;
    this.favoriteLiveEventsSrc.push(eventSRC);
    this.storage.favoriteLiveEventsSRC = this.favoriteLiveEventsSrc;
    this.favoriteEventsCount++;
    this.favoriteListChangedSource.next(this.favoriteEventsCount);
  }

  public getSrcOrderNumbers(sportId: number, regionId: number, competitionId: number): { sportOrder: number; regionOrder: number; competitionOrder: number } {
    return {
      sportOrder: this.sports[sportId] ? this.sports[sportId].orderNo : null,
      regionOrder: this.regions[sportId] && this.regions[sportId][regionId] ? this.regions[sportId][regionId].orderNo : null,
      competitionOrder: this.competitions[regionId] && this.competitions[regionId][competitionId] ? this.competitions[regionId][competitionId].orderNo : null
    };
  }

  removeEventFromFavorites(eventSRC: IEventSrc) {
    if (!this.events[eventSRC.competitionId][eventSRC.eventId]) {
      return;
    }
    this.events[eventSRC.competitionId][eventSRC.eventId].isInFavorite = false;
    const index = this.favoriteLiveEventsSrc.findIndex(item => item.eventId === eventSRC.eventId);
    this.favoriteLiveEventsSrc.splice(index, 1);
    this.storage.favoriteLiveEventsSRC = this.favoriteLiveEventsSrc;
    this.favoriteEventsCount--;
    this.favoriteListChangedSource.next(this.favoriteEventsCount);
  }

  public set eventsForNotifications(eventIds: number[]) {
    this.userEventsForNotifications = eventIds;
    for (const eventId of this.userEventsForNotifications) {
      for (const cmpId of Object.keys(this.events)) {
        if (this.events[+cmpId]) {
          if (this.events[+cmpId][eventId]) {
            this.events[+cmpId][eventId].isNotificationEnabled = true;
          }
        }
      }
    }
  }

  public get eventsForNotifications(): number[] {
    return this.userEventsForNotifications;
  }

  public getSport(sportId: number): ISport {
    return this.sports[sportId];
  }

  public getRegion(sportId: number, regionId: number): IRegion {
    return this.regions[sportId] ? this.regions[sportId][regionId] : null;
  }

  public getCompetition(regionId: number, competitionId): ICompetition {
    return this.competitions[regionId] ? this.competitions[regionId][competitionId] : null;
  }

  private resetCache() {
    this.sports = {};
    this.regions = {};
    this.competitions = {};
    this.events = {};
    this.bets = {};
    this.betOutcomes = {};
    this.betGroupIdsForLoadedBetsInSport = {};
    this.betGroupIdsForLoadedBetsInRegion = {};
    this.betGroupIdsForLoadedBetsInCompetition = {};
    this.betTypeGroupsForHierarchy = {};
    this.betTypeSelectionsForSport = {};
    this.betTypeGroups = {};
    this.treeUpdateTime = pmTreeRefreshTimeSeconds;
    // this.specialOfferEventIds = {};
    this.specialOfferSports = {};
  }

  clearEventsData() {
    this.events = {};
    this.bets = {};
    this.betOutcomes = {};
    this.betGroupIdsForLoadedBetsInSport = {};
    this.betGroupIdsForLoadedBetsInRegion = {};
    this.betGroupIdsForLoadedBetsInCompetition = {};
    this.betTypeSelectionsForSport = {};
    // this.specialOfferEventIds = {};
    // this.specialOfferSports = {};
  }

  clearSportsData() {
    this.sports = {};
    this.regions = {};
    this.competitions = {};
    this.specialOfferSports = {};
    this.treeUpdateTime = pmTreeRefreshTimeSeconds;
  }

  public getSpecialOfferSports(specialOfferType: SpecialOfferType, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions): Observable<IRegion[]> {
    if (!this.specialOfferSports[specialOfferType]) {
      const dates = this.utilityService.getDateFromTo(this.isLive, this.timeFilterForSports);
      // const betTypeShowTypes = this.settingsService.getBetTypeShowTypes();
      // const sportsAndGroupsDictionary = this.eventsProvider.getEventsAndGroupsForFilterWithFirstGroupBets(dates.dateFrom, dates.dateTo, this.isLive, null, null, null, specialEventsType);
      // return forkJoin([betTypeShowTypes, sportsAndGroupsDictionary]).pipe(
      //   switchMap((responses) => {
      //     this.clearEventsData();
      //     this.mapAndAddPMEventsToCache(responses[1], languageCulture, dateFormat, responses[0], null, HierarchyType.Sport, true);
      //     this.cacheChangesService.subscribeForAllChangesPm();
      //     return of(this.sortByOrderNo(this.getSpecialOfferSportsList(specialEventsType)));
      //   })
      // );
      return this.sportsProvider.getSpecialOfferButtons(dates.dateFrom, dates.dateTo).pipe(
        switchMap((specialOfferButtons) => {
          this.clearEventsData();
          for (const specialOfferButton of specialOfferButtons) {
            const sport = this.modelMapper.mapSportFromSpecialOfferButtonTO(specialOfferButton, this.utilityService.getSpecialOfferSportId(specialOfferButton.id));
            for (const region of sport.regions) {
              if (!this.specialOfferSports[sport.specialOfferType]) {
                this.specialOfferSports[sport.specialOfferType] = {};
              }
              this.specialOfferSports[sport.specialOfferType][region.id] = region;
            }
            if (sport.id === this.utilityService.getSpecialOfferSportId(SpecialOfferType.Outrights)) {
              const specials = this.sports[environment.specialsSportId];
              if (ViewConfigurations.showOutrightsAtEnd) {
                sport.orderNo = 999999;
              } else {
                if (specials) {
                  sport.orderNo = specials.orderNo - 1;
                }
              }
            }
          }
          return of(this.sortByOrderNo(this.getSpecialOfferSportsList(specialOfferType)));
        })
      );
    } else {
      return of(this.sortByOrderNo(this.getSpecialOfferSportsList(specialOfferType)));
    }
  }

  private getSpecialOfferSportsList(specialOfferType: SpecialOfferType): IRegion[] {
    if (!this.specialOfferSports[specialOfferType]) {
      return [];
    } else {
      return Object.entries(this.specialOfferSports[specialOfferType]).map(([k, v]) => v);
    }
  }


  private updateCache(cacheChanges: ICacheChanges, updateSportTreeCounters: boolean) {
    const dates = !this.isLive ? this.utilityService.getDateFromTo(this.isLive, this.timeFilterForSports) : null;
    const updateEventsChangesResult = this.updateEventsChanges(cacheChanges.changedEvents, updateSportTreeCounters, dates);
    const sportTreeElementsWithAddedRemovedEventsChanged: ISrcSelectionIds[] = updateEventsChangesResult.sportTreeElementsWithAddedRemovedEventsChanged;

    if (updateEventsChangesResult.hasNewSportTreeElements || updateEventsChangesResult.filterSportsOnUpdate) {

      if (!this.isLive) {
        const dates = this.utilityService.getDateFromTo(this.isLive, this.timeFilterForSports);
        this.getSportsFromServerAndAddToCache(dates.dateFrom, dates.dateTo, this.isLive, true, updateEventsChangesResult.filterSportsOnUpdate).subscribe(x => this.sportTreeChangedSource.next());
      }
    }

    if (sportTreeElementsWithAddedRemovedEventsChanged.length > 0) {
      this.sportTreeElementsWithAddedRemovedEventsChangedSource.next(sportTreeElementsWithAddedRemovedEventsChanged);
    }

    // if bet or outcome is added add event id to this list so event can pull new bets
    const eventIdsOfAddedOrRemovedBetsAndOutcomes: number[] = [];

    this.updateBetChanges(cacheChanges.changedBets, eventIdsOfAddedOrRemovedBetsAndOutcomes, dates);
    this.updateBetOutcomesChanges(cacheChanges.changedBetOutcomes, eventIdsOfAddedOrRemovedBetsAndOutcomes, dates);

    if (eventIdsOfAddedOrRemovedBetsAndOutcomes.length > 0) {
      this.betsAndOutcomesAddedRemovedSource.next(eventIdsOfAddedOrRemovedBetsAndOutcomes);
    }

    this.updateResultChanges(cacheChanges.changedResults);
  }

  private updateEventsChanges(changedEvents: EventVM[], updateSportTreeCounters: boolean, datesForFilter?: { dateFrom: Date; dateTo: Date }): { sportTreeElementsWithAddedRemovedEventsChanged: ISrcSelectionIds[]; hasNewSportTreeElements: boolean; filterSportsOnUpdate: boolean } {
    // this can be passed to observable
    const sportTreeElementsWithAddedRemovedEventsChanged: ISrcSelectionIds[] = [];
    const dateNow: Date = new Date();
    if (this.isLive) {
      // used when adding events to cache - only started and events that are starting in next 5 minutes will be added
      dateNow.setMinutes(dateNow.getMinutes() + 5);
    }

    if (!this.isLive) {
      if (this.updatedCacheTimePM > 10) {
        this.removeStartedEvents(sportTreeElementsWithAddedRemovedEventsChanged);
        this.updatedCacheTimePM = 0;
      }
      this.updatedCacheTimePM += ConstantValues.CACHE_INTERVAL_PM_SEC;
    }

    let hasNewSportTreeElements = false;
    let filterSportsOnUpdate = false;
    const addedLiveEvents: EventVM[] = [];
    const changedEventsForMostPopularOrSoonSportIds: number[] = [];

    for (const changedEvent of changedEvents) {
      // no mixed events in cache
      if (this.isLive !== changedEvent.isLive) {
        continue;
      }

      if (changedEvent.isInOffer) {
        // add or update
        if (this.events[changedEvent.competitionId] && this.events[changedEvent.competitionId][changedEvent.id]) {
          // update
          if (!changedEvent.isLive && this.events[changedEvent.competitionId][changedEvent.id].dateTime !== changedEvent.dateTime) {
            if (changedEvent.dateTime < datesForFilter.dateFrom || changedEvent.dateTime > datesForFilter.dateTo) {
              const getSportTree = this.removeEventOnUpdate(changedEvent, changedEventsForMostPopularOrSoonSportIds, sportTreeElementsWithAddedRemovedEventsChanged, datesForFilter, true, updateSportTreeCounters);
              if (getSportTree) {
                filterSportsOnUpdate = true;
              }
              continue;
            }
            this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, changedEvent.specialOfferType));
            if (changedEvent.specialOfferType) {
              this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, this.utilityService.getSpecialOfferSportId(changedEvent.specialOfferType), changedEvent.sportId, changedEvent.competitionId, changedEvent.specialOfferType));
            }
          }
          this.events[changedEvent.competitionId][changedEvent.id].updateEventDetails(changedEvent);
        } else {
          // for cro mobile dont add
          if (this.utilityService.mobileView && ViewConfigurations.useMobileViewWithTopMenu && !this.isLive && (!this.events || !this.events[changedEvent.competitionId])) {
            continue;
          }

          // if is mostpopular or soon reload events
          // if (this.pageType === PageType.MostPopular || this.pageType === PageType.Soon) {
          //   if (!changedEventsForMostPopularOrSoonSportIds.includes(changedEvent.sportId)) {
          //     changedEventsForMostPopularOrSoonSportIds.push(changedEvent.sportId);
          //   }
          // }

          // add event
          const getDataForLiveSRCIds: ISrcSelectionIds[] = [];
          if (this.isLive) {

            if (changedEvent.dateTime > dateNow) {
              continue;
            }

            if (this.isEventInFavorites(changedEvent.id)) {
              changedEvent.isInFavorite = true;
              this.favoriteEventsCount++;
              this.favoriteListChangedSource.next(this.favoriteEventsCount);
            }

            addedLiveEvents.push(changedEvent);

            if (!this.regions[changedEvent.sportId]) {
              this.regions[changedEvent.sportId] = {};
            }

            if (!this.competitions[changedEvent.regionId]) {
              this.competitions[changedEvent.regionId] = {};
            }
            if (!this.sports[changedEvent.sportId]) {
              if (getDataForLiveSRCIds.findIndex(src => src.sId === changedEvent.sportId) > -1) {
                continue;
              }

              const selectionSrcIds = { sId: changedEvent.sportId, rId: null, cId: null, isLive: true } as ISrcSelectionIds;
              getDataForLiveSRCIds.push(selectionSrcIds);

              this.sportsProvider.getSportForLiveEvent(changedEvent).subscribe(async sp => {
                const sportWithSelections = await this.mapISportWithSelectionsWithFirstRegAndCmp(sp);
                // test if this cause error if more than 1 event calls (will be counter good??? )
                this.addNewSportForEvent(sportWithSelections, changedEvent);
                this.sportTreeElementsWithAddedRemovedEventsChangedSource.next([selectionSrcIds]);
              });

            } else if (!this.regions[changedEvent.sportId][changedEvent.regionId]) {
              if (getDataForLiveSRCIds.findIndex(src => src.sId === changedEvent.sportId && src.rId === changedEvent.regionId) > -1) {
                continue;
              }
              const selectionSrcIds = { sId: changedEvent.sportId, rId: changedEvent.regionId, cId: null, isLive: true } as ISrcSelectionIds;
              getDataForLiveSRCIds.push(selectionSrcIds);

              // mapISportWithSelectionsWithFirstRegAndCmp
              this.sportsProvider.getSportForLiveEvent(changedEvent).subscribe(async sp => {
                const sportWithSelections = await this.mapISportWithSelectionsWithFirstRegAndCmp(sp);
                this.addNewRegionForEvent(sportWithSelections, changedEvent);
                this.sportTreeElementsWithAddedRemovedEventsChangedSource.next([selectionSrcIds]);
              });
            } else if (!this.competitions[changedEvent.regionId][changedEvent.competitionId]) {
              if (getDataForLiveSRCIds.findIndex(src => src.sId === changedEvent.sportId && src.rId === changedEvent.regionId && src.cId === changedEvent.competitionId) > -1) {
                continue;
              }
              const selectionSrcIds = this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, changedEvent.specialOfferType);
              getDataForLiveSRCIds.push(selectionSrcIds);

              this.sportsProvider.getSportForLiveEvent(changedEvent).subscribe(async sp => {
                const sportWithSelections = await this.mapISportWithSelectionsWithFirstRegAndCmp(sp);
                this.addNewCompetitionForEvent(sportWithSelections, changedEvent);
                this.sportTreeElementsWithAddedRemovedEventsChangedSource.next([selectionSrcIds]);
              });
            } else {
              changedEvent.sportName = this.sports[changedEvent.sportId].name;
              changedEvent.regionName = this.regions[changedEvent.sportId][changedEvent.regionId].name;
              changedEvent.competitionName = this.competitions[changedEvent.regionId][changedEvent.competitionId].name;
            }
            if (!this.events[changedEvent.competitionId]) {
              this.events[changedEvent.competitionId] = {};
            }
          }

          if (!changedEvent.isLive &&
            (
              (
                (!this.competitions[changedEvent.regionId] || !this.competitions[changedEvent.regionId][changedEvent.competitionId])

                && !changedEvent.specialOfferType
              )
              ||
              (changedEvent.specialOfferType
                && (!this.specialOfferSports[changedEvent.specialOfferType] || !this.specialOfferSports[changedEvent.specialOfferType][changedEvent.sportId])
              )
            )
          ) {
            if (changedEvent.dateTime >= datesForFilter.dateFrom && changedEvent.dateTime <= datesForFilter.dateTo) {
              hasNewSportTreeElements = true;
            }
          } else {
            // add event only if competition exists (we are not loading complete offer) so every competition needs to be downloaded on click if we add on click condition will prevent going on server for data
            if (this.events[changedEvent.competitionId] || (changedEvent.specialOfferType && this.loadedEventsType === changedEvent.specialOfferType)) {
              if (!this.events[changedEvent.competitionId]) {
                this.events[changedEvent.competitionId] = {};
              }
              this.events[changedEvent.competitionId][changedEvent.id] = changedEvent;
              this.settingsService.getBetTypeShowTypes().subscribe(betTypeShowTypes => {
                this.eventsProvider.getBetsAndGroups(changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, changedEvent.id).subscribe((betsAndGroupsTO) => {
                  changedEvent.betsCount = this.mapAndAddBetsToCacheAndGetPlayableCount(betsAndGroupsTO.bets, false, betTypeShowTypes, changedEvent);
                  this.betsAndOutcomesAddedRemovedSource.next([changedEvent.id]);
                });
              });
            }

            if ((changedEvent.isLive && this.isLive) || (!changedEvent.isLive && !this.isLive && changedEvent.dateTime >= datesForFilter.dateFrom && changedEvent.dateTime <= datesForFilter.dateTo)) {
              if (updateSportTreeCounters && (this.isLive || this.betGroupIdsForLoadedBetsInSport[changedEvent.sportId] || this.betGroupIdsForLoadedBetsInRegion[changedEvent.regionId] || this.betGroupIdsForLoadedBetsInCompetition[changedEvent.competitionId])) {
                this.updateCountersForSportTree(changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, true, changedEvent.specialOfferType);
              }
              //  ask here if it is in list for changed live tree elements if it is dont add it
              const srcSelectionIds: ISrcSelectionIds = this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, changedEvent.specialOfferType);
              if (!this.isLive || getDataForLiveSRCIds.findIndex(src => (src.sId === srcSelectionIds.sId && src.rId === srcSelectionIds.rId && src.cId === null) || (src.sId === srcSelectionIds.sId && src.rId === srcSelectionIds.rId && src.cId === srcSelectionIds.cId)) < 0) {
                this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, srcSelectionIds);
                if (changedEvent.specialOfferType) {
                  this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, this.utilityService.getSpecialOfferSportId(changedEvent.specialOfferType), changedEvent.sportId, changedEvent.competitionId, changedEvent.specialOfferType));
                }
              }
            }
          }
        }
      } else {

        // remove event
        if (this.utilityService.mobileView && ViewConfigurations.useMobileViewWithTopMenu && !this.isLive && (!this.events || !this.events[changedEvent.competitionId])) {
          continue;
        }


        if (changedEvent.status === EventStatus.Finished && changedEvent.isLive) {
          if (this.events[changedEvent.competitionId] && this.events[changedEvent.competitionId][changedEvent.id]) {
            this.events[changedEvent.competitionId][changedEvent.id].updateEventDetails(changedEvent);
            setTimeout(() => {
              const sportTreeElemsNotify: ISrcSelectionIds[] = [];
              this.removeEventOnUpdate(changedEvent, changedEventsForMostPopularOrSoonSportIds, sportTreeElemsNotify, datesForFilter, false, updateSportTreeCounters);
              this.sportTreeElementsWithAddedRemovedEventsChangedSource.next(sportTreeElemsNotify);
            }, ViewConfigurations.timeToDelayRemovingFinishedLiveEvent);
          }
        } else {
          const getSportTree = this.removeEventOnUpdate(changedEvent, changedEventsForMostPopularOrSoonSportIds, sportTreeElementsWithAddedRemovedEventsChanged, datesForFilter, false, updateSportTreeCounters);
          if (getSportTree) {
            filterSportsOnUpdate = true;
          }
        }
      }
    }

    if (addedLiveEvents.length > 0) {
      this.getLiveResultsForEventsAndAddToEvents(addedLiveEvents.map(ev => ev.id));
      this.eventsProvider.checkForVideoStream(addedLiveEvents.map(ev => ev.betRadarEventId)).subscribe((response) => {
        for (const resp of response) {
          const ev = addedLiveEvents.find(eventList => eventList.betRadarEventId === resp.betradarEventId);
          if (ev) {
            ev.liveStreamId = resp.streamId;
          }
        }
      });
    }

    if (changedEventsForMostPopularOrSoonSportIds.length > 0) {
      this.mostPopularOrSoonEventAddedRemovedSource.next(changedEventsForMostPopularOrSoonSportIds);
    }

    return { sportTreeElementsWithAddedRemovedEventsChanged, hasNewSportTreeElements, filterSportsOnUpdate };
  }

  private removeEventOnUpdate(changedEvent: EventVM, changedEventsForMostPopularOrSoonSportIds: number[], sportTreeElementsWithAddedRemovedEventsChanged: ISrcSelectionIds[], datesForFilter: { dateFrom: Date; dateTo: Date }, removeOnDateUpdated: boolean, updateSportTreeCounters: boolean): boolean {
    const eventExists = this.events[changedEvent.competitionId] && this.events[changedEvent.competitionId][changedEvent.id];
    if (eventExists) {

      delete this.events[changedEvent.competitionId][changedEvent.id];
      if (changedEvent.isLive && this.isEventInFavorites(changedEvent.id)) {
        this.favoriteEventsCount--;
      }
      // only refresh when some of events on view are removed/not from other sports from soon or top offer(not most acurate but better for ui)
      if (this.pageType === PageType.MostPopular || this.pageType === PageType.Soon) {
        if (!changedEventsForMostPopularOrSoonSportIds.includes(changedEvent.sportId)) {
          changedEventsForMostPopularOrSoonSportIds.push(changedEvent.sportId);
        }
      }

      if (changedEvent.isLive && this.isLive) {
        if (updateSportTreeCounters) {
          this.updateCountersForSportTree(changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, false, changedEvent.specialOfferType);
        }
        this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, changedEvent.specialOfferType));
      }
    }

    if (removeOnDateUpdated || (!changedEvent.isLive && changedEvent.dateTime >= datesForFilter.dateFrom && changedEvent.dateTime <= datesForFilter.dateTo && eventExists)) {
      if (updateSportTreeCounters) {
        this.updateCountersForSportTree(changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, false, changedEvent.specialOfferType);
      }
      this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, changedEvent.sportId, changedEvent.regionId, changedEvent.competitionId, changedEvent.specialOfferType));
      if (changedEvent.specialOfferType) {
        this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(changedEvent.isLive, this.utilityService.getSpecialOfferSportId(changedEvent.specialOfferType), changedEvent.sportId, changedEvent.competitionId, changedEvent.specialOfferType));
      }
    } else {
      if (!changedEvent.isLive && changedEvent.dateTime >= datesForFilter.dateFrom && changedEvent.dateTime <= datesForFilter.dateTo) {
        return true;
      }
    }
    return false;
  }

  public decrementSrcs(srcsToDecrement: ISrcSelectionIds[]) {
    const srcsToSend: ISrcSelectionIds[] = [];
    if (!srcsToDecrement || srcsToDecrement.length === 0) {
      return;
    }
    for (const srcSelection of srcsToDecrement) {
      if (srcSelection.sOT !== SpecialOfferType.SuperBet || ViewConfigurations.showSpecialEventsInStandardOffer) {
        if (!this.sports[srcSelection.sId] || this.sports[srcSelection.sId].eventsCount < 1) {
          continue;
        }

        this.sports[srcSelection.sId].eventsCount--;

        if (!this.regions[srcSelection.sId] || !this.regions[srcSelection.sId][srcSelection.rId] || this.regions[srcSelection.sId][srcSelection.rId].eventsCount < 1) {
          continue;
        }

        this.regions[srcSelection.sId][srcSelection.rId].eventsCount--;

        if (!this.competitions[srcSelection.rId] || !this.competitions[srcSelection.rId][srcSelection.cId] || this.competitions[srcSelection.rId][srcSelection.cId].eventsCount < 1) {
          continue;
        }

        this.competitions[srcSelection.rId][srcSelection.cId].eventsCount--;
      }

      if (srcSelection.sOT) {
        // for special sports
        if (this.specialOfferSports[srcSelection.sOT] && this.specialOfferSports[srcSelection.sOT][srcSelection.sId]) {
          this.specialOfferSports[srcSelection.sOT][srcSelection.sId].eventsCount--;
        }
        const specialOfferSportId = this.utilityService.getSpecialOfferSportId(srcSelection.sOT);
        if (this.sports[specialOfferSportId]) {
          this.sports[specialOfferSportId].eventsCount--;
        }
      }

      if (srcsToSend.findIndex(s => s.sId === srcSelection.sId && s.rId === srcSelection.rId && s.cId === srcSelection.cId)) {
        srcsToSend.push(srcSelection);
      }
    }

    this.sportTreeElementsWithAddedRemovedEventsChangedSource.next(srcsToSend);
  }

  private addNewSportForEvent(sportWithSelections: ISportWithSelections, event: EventVM) {
    sportWithSelections.sport.eventsCount = 1;
    event.sportName = sportWithSelections.sport.name;
    this.sports[event.sportId] = sportWithSelections.sport;
    if (!this.betTypeSelectionsForSport[sportWithSelections.sport.id]) {
      this.betTypeSelectionsForSport[sportWithSelections.sport.id] = sportWithSelections.selections;
    }
    this.addNewRegionForEvent(sportWithSelections, event);
  }

  private addNewRegionForEvent(sportWithSelections: ISportWithSelections, event: EventVM) {
    event.sportName = sportWithSelections.sport.name;
    event.regionName = sportWithSelections.sport.regions[0].name;
    sportWithSelections.sport.regions[0].eventsCount = 1;
    if (!this.regions[event.sportId]) {
      this.regions[event.sportId] = {};
    }
    this.regions[event.sportId][event.regionId] = sportWithSelections.sport.regions[0];
    this.addNewCompetitionForEvent(sportWithSelections, event);
  }

  private addNewCompetitionForEvent(sportWithSelections: ISportWithSelections, event: EventVM) {
    event.sportName = sportWithSelections.sport.name;
    event.regionName = sportWithSelections.sport.regions[0].name;
    event.competitionName = sportWithSelections.sport.regions[0].competitions[0].name;
    sportWithSelections.sport.regions[0].competitions[0].eventsCount = 1;
    if (!this.competitions[event.regionId]) {
      this.competitions[event.regionId] = {};
    }
    this.competitions[event.regionId][event.competitionId] = sportWithSelections.sport.regions[0].competitions[0];
  }

  removeStartedEvents(sportTreeElementsWithAddedRemovedEventsChanged: ISrcSelectionIds[]) {
    const dateNow = new Date();
    const cmpKeys = Object.keys(this.events);
    const changedEventsForMostPopularOrSoonSportIds: number[] = [];
    for (const competitionId of cmpKeys) {
      const evKeys = Object.keys(this.events[+competitionId]);
      for (const eventId of evKeys) {
        if (this.events[+competitionId][+eventId].dateTime <= dateNow) {
          this.updateCountersForSportTree(this.events[+competitionId][+eventId].sportId, this.events[+competitionId][+eventId].regionId, this.events[+competitionId][+eventId].competitionId, false, this.events[+competitionId][+eventId].specialOfferType);

          this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(this.events[+competitionId][+eventId].isLive, this.events[+competitionId][+eventId].sportId, this.events[+competitionId][+eventId].regionId, this.events[+competitionId][+eventId].competitionId, this.events[+competitionId][+eventId].specialOfferType ));
          if (this.events[+competitionId][+eventId].specialOfferType) {
            this.addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElementsWithAddedRemovedEventsChanged, this.modelMapper.createSrcSelectionIdsFromEventParams(this.events[+competitionId][+eventId].isLive, this.utilityService.getSpecialOfferSportId(this.events[+competitionId][+eventId].specialOfferType), this.events[+competitionId][+eventId].sportId, this.events[+competitionId][+eventId].competitionId, this.events[+competitionId][+eventId].specialOfferType));
          }

          if (this.pageType === PageType.MostPopular || this.pageType === PageType.Soon) {
            if (!changedEventsForMostPopularOrSoonSportIds.includes(this.events[+competitionId][+eventId].sportId)) {
              changedEventsForMostPopularOrSoonSportIds.push(this.events[+competitionId][+eventId].sportId);
            }
          }
          delete this.events[+competitionId][+eventId];
        }
      }
    }

    if (changedEventsForMostPopularOrSoonSportIds.length > 0) {
      this.mostPopularOrSoonEventAddedRemovedSource.next(changedEventsForMostPopularOrSoonSportIds);
    }
  }

  // private getHierarchyIdForBetTypeGroups(sportId: number, regionId: number, competitionId: number): number {
  //   switch (this.betTypeGroupsForHierarchy.hierarchyType) {
  //     case HierarchyType.Competition:
  //       return sportId;
  //     case HierarchyType.Region:
  //       return regionId;
  //     default:
  //       return sportId;
  //   }
  // }

  updateBetChanges(changedBets: IBet[], eventIdsOfAddedOrRemovedBetsAndOutcomes: number[], datesForFilter?: { dateFrom: Date; dateTo: Date }) {
    for (const changedBet of changedBets) {
      if (this.isLive !== changedBet.isLive) {
        continue;
      }
      const eventForBet = this.events[changedBet.competitionId] ? this.events[changedBet.competitionId][changedBet.eventId] : null;
      if (changedBet.isInOffer) {
        // add or update
        if (this.bets[changedBet.eventId]
          && this.bets[changedBet.eventId][changedBet.betTypeId]
          && this.bets[changedBet.eventId][changedBet.betTypeId][changedBet.id]) {
          // update
          if (this.bets[changedBet.eventId][changedBet.betTypeId][changedBet.id].isPlayable !== changedBet.isPlayable && eventForBet) {
            if (changedBet.isPlayable) {
              eventForBet.betsCount++;
            } else {
              if (eventForBet.betsCount > 0) {
                eventForBet.betsCount--;
              }
            }
          }
          this.updateSingleBet(changedBet, this.bets[changedBet.eventId][changedBet.betTypeId][changedBet.id]);
        } else {
          // add
          if (!this.bets[changedBet.eventId]) {
            this.bets[changedBet.eventId] = {};
          }

          if (!this.bets[changedBet.eventId][changedBet.betTypeId]) {
            this.bets[changedBet.eventId][changedBet.betTypeId] = {};
          }

          this.bets[changedBet.eventId][changedBet.betTypeId][changedBet.id] = changedBet;
          if (eventForBet && (eventForBet.isLive || eventForBet.dateTime >= datesForFilter.dateFrom && eventForBet.dateTime <= datesForFilter.dateTo)) {
            if (!eventIdsOfAddedOrRemovedBetsAndOutcomes.includes(changedBet.eventId)) {
              eventIdsOfAddedOrRemovedBetsAndOutcomes.push(changedBet.eventId);
              // this increment/decrement should come from server and affect events count on event update
              // const groupsHierarchyId = this.getHierarchyIdForBetTypeGroups(eventForBet.sportId, eventForBet.regionId, eventForBet.competitionId);
              if (
                (!eventForBet.isLive &&
                  (
                    (this.pageType === PageType.Prematch &&
                      this.betTypeGroupsForHierarchy[HierarchyType.Competition] &&
                      this.betTypeGroupsForHierarchy[HierarchyType.Competition].betTypeGroupIds[eventForBet.competitionId] &&
                      this.betTypeGroupsForHierarchy[HierarchyType.Competition].betTypeGroupIds[eventForBet.competitionId].includes(changedBet.betTypeId)
                    )
                    ||
                    (this.pageType !== PageType.Prematch &&
                      this.betTypeGroupsForHierarchy[HierarchyType.Sport] &&
                      this.betTypeGroupsForHierarchy[HierarchyType.Sport].betTypeGroupIds[eventForBet.sportId] &&
                      this.betTypeGroupsForHierarchy[HierarchyType.Sport].betTypeGroupIds[eventForBet.sportId].includes(changedBet.betTypeId)
                    )
                  )
                )
                ||
                (eventForBet.isLive &&
                  this.betTypeSelectionsForSport[changedBet.sportId] &&
                  this.betTypeSelectionsForSport[changedBet.sportId].findIndex(s => s.betTypeId === changedBet.betTypeId) > -1)
              ) {

                if (changedBet.isPlayable) {
                  eventForBet.betsCount++;
                } else {
                  if (eventForBet.betsCount > 0) {
                    eventForBet.betsCount--;
                  }
                }
              }
            }
          }
        }
      } else {
        // delete
        if (this.bets[changedBet.eventId]
          && this.bets[changedBet.eventId][changedBet.betTypeId]
          && this.bets[changedBet.eventId][changedBet.betTypeId][changedBet.id]) {

          delete this.bets[changedBet.eventId][changedBet.betTypeId][changedBet.id];
          if (eventForBet && eventForBet.betsCount > 0) {
            eventForBet.betsCount--;
          }

          if (eventForBet && (eventForBet.isLive || eventForBet.dateTime >= datesForFilter.dateFrom && eventForBet.dateTime <= datesForFilter.dateTo)) {
            if (!eventIdsOfAddedOrRemovedBetsAndOutcomes.includes(changedBet.eventId)) {
              eventIdsOfAddedOrRemovedBetsAndOutcomes.push(changedBet.eventId);
            }
          }
        }
      }
    }
  }

  selectBetOutcomeFromTicket(identifier: ITicketItemIdentifier) {
    if (!this.betOutcomes[identifier.betId] || !this.betOutcomes[identifier.betId][identifier.betTypeOutcomeId] || !this.betOutcomes[identifier.betId][identifier.betTypeOutcomeId][identifier.betOutcomeId]) {
      return;
    }

    if (identifier.isAdded) {
      this.betOutcomes[identifier.betId][identifier.betTypeOutcomeId][identifier.betOutcomeId].isSelected = true;
    } else {
      this.betOutcomes[identifier.betId][identifier.betTypeOutcomeId][identifier.betOutcomeId].isSelected = false;
    }
  }

  updateBetOutcomesChanges(changedOutcomes: IBetOutcome[], eventIdsOfAddedOrRemovedBetsAndOutcomes: number[], datesForFilter?: { dateFrom: Date; dateTo: Date }) {
    for (const changedOutcome of changedOutcomes) {
      if (this.isLive !== changedOutcome.isLive) {
        continue;
      }
      const eventForBet = this.events[changedOutcome.competitionId] ? this.events[changedOutcome.competitionId][changedOutcome.eventId] : null;
      if (changedOutcome.isInOffer) {
        // add or update
        if (this.betOutcomes[changedOutcome.betId]
          && this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId]
          && this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId][changedOutcome.id]) {
          // update
          this.updateSingleBetOutcome(changedOutcome, this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId][changedOutcome.id]);
        } else {
          // add
          if (!this.betOutcomes[changedOutcome.betId]) {
            this.betOutcomes[changedOutcome.betId] = {};
          }

          if (!this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId]) {
            this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId] = {};
          }

          this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId][changedOutcome.id] = changedOutcome;

          if (eventForBet && (eventForBet.isLive || eventForBet.dateTime >= datesForFilter.dateFrom && eventForBet.dateTime <= datesForFilter.dateTo)) {
            if (!eventIdsOfAddedOrRemovedBetsAndOutcomes.includes(changedOutcome.eventId)) {
              eventIdsOfAddedOrRemovedBetsAndOutcomes.push(changedOutcome.eventId);
            }
          }
        }
      } else {
        // delete
        if (this.betOutcomes[changedOutcome.betId]
          && this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId]
          && this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId][changedOutcome.id]) {

          delete this.betOutcomes[changedOutcome.betId][changedOutcome.betTypeOutcomeId][changedOutcome.id];

          if (eventForBet && (eventForBet.isLive || eventForBet.dateTime >= datesForFilter.dateFrom && eventForBet.dateTime <= datesForFilter.dateTo)) {
            if (!eventIdsOfAddedOrRemovedBetsAndOutcomes.includes(changedOutcome.eventId)) {
              eventIdsOfAddedOrRemovedBetsAndOutcomes.push(changedOutcome.eventId);
            }
          }
        }
      }
    }
  }

  updateResultChanges(changedResults: IEventLiveResultInfo[]) {
    for (const result of changedResults) {
      if (this.events[result.competitionId] && this.events[result.competitionId][result.eventId]) {
        this.events[result.competitionId][result.eventId].result = result;
      }
    }
  }

  private updateCountersForSportTree(sportId: number, regionId: number, competitionId: number, isEventAdded: boolean, specialOfferType: SpecialOfferType) {

    if (specialOfferType) {
      const specialOfferSportId = this.utilityService.getSpecialOfferSportId(specialOfferType);
      // for special sports
      if (this.specialOfferSports[specialOfferType] && this.specialOfferSports[specialOfferType][sportId]) {
        this.specialOfferSports[specialOfferType][sportId].eventsCount += isEventAdded ? 1 : -1;
      }
      if (this.sports[specialOfferSportId]) {
        this.sports[specialOfferSportId].eventsCount += isEventAdded ? 1 : -1;
      }
    }

    if (specialOfferType === SpecialOfferType.SuperBet && !ViewConfigurations.showSpecialEventsInStandardOffer) {
      return;
    }

    if (this.sports[sportId]) {
      this.sports[sportId].eventsCount += isEventAdded ? 1 : -1;
    }

    if (this.regions[sportId] && this.regions[sportId][regionId]) {
      this.regions[sportId][regionId].eventsCount += isEventAdded ? 1 : -1;
    }

    if (this.competitions[regionId] && this.competitions[regionId][competitionId]) {
      this.competitions[regionId][competitionId].eventsCount += isEventAdded ? 1 : -1;
    }
  }

  private addSportTreeElementsWithAddedRemovedEventsToList(sportTreeElements: ISrcSelectionIds[], sportTreeElement: ISrcSelectionIds): ISrcSelectionIds[] {
    if (sportTreeElements.findIndex(ste => ste.sId === sportTreeElement.sId && ste.rId === sportTreeElement.rId && ste.cId === sportTreeElement.cId && ste.isLive === sportTreeElement.isLive) < 0) {
      sportTreeElements.push(sportTreeElement);
    }
    return sportTreeElements;
  }

  // ovde
  // betGroups for event should be set or component can ask for bets for event
  getCompletePMOfferForFilter(timeFilter: TimeFilter, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions, sportId?: number, regionId?: number, competitionId?: number, specialOfferType?: SpecialOfferType): Observable<IEventsGroupComponentViewModel[]> {
    if (timeFilter !== this.timeFilterForEvents) {
      this.clearEventsData();
      return this.settingsService.getBetTypeShowTypes().pipe(
        switchMap(betTypeShowTypes => {
          this.timeFilterForEvents = timeFilter;
          const dates = this.utilityService.getDateFromTo(false, timeFilter);
          return this.eventsProvider.getEventsAndGroupsForFilterWithFirstGroupBets(dates.dateFrom, dates.dateTo, false).pipe(
            switchMap((eventsAndGroupsConfigurations) => {
              this.clearEventsData();
              this.mapAndAddPMEventsToCache(eventsAndGroupsConfigurations,
                languageCulture,
                dateFormat,
                betTypeShowTypes,
                competitionId ? competitionId : (regionId ? regionId : sportId),
                competitionId ? HierarchyType.Competition : (regionId ? HierarchyType.Region : HierarchyType.Sport), sportId);
              this.cacheChangesService.subscribeForAllChangesPm();
              return this.getEventGroupsBySRCIdsAsync(sportId, regionId, competitionId, specialOfferType).pipe(
                switchMap((eventGroups) => of(this.sortByOrderNo(eventGroups))));
            }));
        })
      );
    } else {
      return this.getEventGroupsBySRCIdsAsync(sportId, regionId, competitionId, specialOfferType).pipe(
        switchMap((eventGroups) => of(this.sortByOrderNo(eventGroups))));
    }
  }

  // dont call for special offer
  getEventsGroupForFilter(timeFilter: TimeFilter, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions, sportId: number, regionId: number, competitionId: number, specialOfferType: SpecialOfferType): Observable<IEventsGroupComponentViewModel> {
    if (this.loadedEventsType !== specialOfferType || this.timeFilterForEvents !== timeFilter) {
      this.clearEventsData();
      this.loadedEventsType = specialOfferType;
    }
    let goToServer = timeFilter !== this.timeFilterForEvents;

    // go to server if bettypegroups or events are not loaded(dependandt of hierarchy type and id)
    if (competitionId) {
      // goToServer = (!this.events[competitionId] || Object.keys(this.events[competitionId]).length < this.competitions[regionId][competitionId].eventsCount)
      goToServer = goToServer || (!this.events[competitionId] || Object.keys(this.events[competitionId]).length < 1)
        // added part for cro to go to server because after region is loaded there is no groups for competition-- this only should go for groups
        || (!this.betTypeGroupsForHierarchy[HierarchyType.Competition] || !this.betTypeGroupsForHierarchy[HierarchyType.Competition].betTypeGroupIds || !this.betTypeGroupsForHierarchy[HierarchyType.Competition].betTypeGroupIds[competitionId]);

    } else {
      const cmps = this.competitions[regionId];
      if (!cmps) {
        return of({
          events: [],
          betTypeGroups: [],

        } as IEventsGroupComponentViewModel);

      }
      const k = Object.keys(cmps);
      const competitionIds: number[] = Object.keys(this.competitions[regionId]).map(cId => (+cId));
      for (const cmpId of competitionIds) {
        if (goToServer) {
          break;
        }
        goToServer = !this.events[cmpId] || Object.keys(this.events[cmpId]).length < 1;

        // if setting this way after getting events competition /event / region event counts should be set
        // goToServer = !this.events[cmpId] || !this.competitions[regionId] || !this.competitions[regionId][competitionId] || Object.keys(this.events[cmpId]).length < this.competitions[regionId][competitionId].eventsCount;
      }
    }

    // only this was checked for sebian
    // if (!this.events[competitionId] || Object.keys(this.events[competitionId]).length < 1 || timeFilter !== this.timeFilterForEvents) {
    if (goToServer) {
      return this.getPMEventsGroupForFilterWithEventsFromServer(timeFilter, languageCulture, dateFormat, sportId, regionId, competitionId, specialOfferType, competitionId ? HierarchyType.Competition : HierarchyType.Region);

    } else {
      return this.getEventGroupsBySRCIdsAsync(sportId, regionId, competitionId, specialOfferType).pipe(
        switchMap((eventGroups) => of(eventGroups[0])));
    }
  }

  getEventsGroupForSpecialOfferFilter(timeFilter: TimeFilter, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions, sportId: number, specialOfferType: SpecialOfferType): Observable<IEventsGroupComponentViewModel> {
    if (this.loadedEventsType !== specialOfferType || this.timeFilterForEvents !== timeFilter) {
      this.clearEventsData();
      this.loadedEventsType = specialOfferType;
      return this.getPMEventsGroupForFilterWithEventsFromServer(timeFilter, languageCulture, dateFormat, sportId, null, null, specialOfferType, HierarchyType.Sport);

    } else {
      // no other way to know if current sport events are loaded
      return this.getEventGroupsBySRCIdsAsync(sportId, null, null, specialOfferType).pipe(
        switchMap((eventGroups) => {
          const evGroup = eventGroups[0];
          if (evGroup && this.specialOfferSports[specialOfferType] && this.specialOfferSports[specialOfferType][sportId] && evGroup.events.length < this.specialOfferSports[specialOfferType][sportId].eventsCount) {
            return this.getPMEventsGroupForFilterWithEventsFromServer(timeFilter, languageCulture, dateFormat, sportId, null, null, specialOfferType, HierarchyType.Sport);
          } else {
            return of(evGroup);
          }
        } ));

      // return of(this.getEventGroupsBySRCIds(sportId, null, null, eventsType)[0]);
    }
  }

  getPMEventsGroupForFilterWithEventsFromServer(
    timeFilter: TimeFilter,
    languageCulture: string,
    dateFormat: Intl.DateTimeFormatOptions,
    sportId: number,
    regionId: number,
    competitionId: number,
    specialOfferType: SpecialOfferType,
    hierearchyType: HierarchyType): Observable<IEventsGroupComponentViewModel> {
    let betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType };
    return this.settingsService.getBetTypeShowTypes().pipe(
      switchMap(x => {
        // console.log('Cache GetBettypeshowtypes');
        betTypeShowTypes = x;
        this.timeFilterForEvents = timeFilter;
        const dates = this.utilityService.getDateFromTo(false, timeFilter);
        return this.eventsProvider.getEventsAndGroupsForFilterWithFirstGroupBets(
          dates.dateFrom,
          dates.dateTo,
          false,
          sportId,
          regionId,
          competitionId,
          specialOfferType ? null : (ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]),
          specialOfferType).pipe(
          switchMap((eventsAndGroupsConfigurations) => {
            this.clearEventsData();
            this.mapAndAddPMEventsToCache(eventsAndGroupsConfigurations, languageCulture, dateFormat, betTypeShowTypes, hierearchyType === HierarchyType.Sport ? sportId : (hierearchyType === HierarchyType.Region ? regionId : competitionId), hierearchyType, sportId);
            return this.getEventGroupsBySRCIdsAsync(sportId, regionId, competitionId, specialOfferType).pipe(
              switchMap((eventGroups) => of(eventGroups[0])));
          })
        );
      })
    );
  }

  getEventsGroupForEventsStartingSoonForDate(sportId: number, page: number, clearData: boolean, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions, timeFilter?: TimeFilter, eventMappingTypes: EventMappingType[] = []): Observable<IEventsGroupComponentViewModel> {
    if (clearData) {
      this.clearEventsData();
    }

    if (clearData) {
      const dates = this.utilityService.getDateFromTo(this.isLive, timeFilter);
      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const cmpAndBtGroupsWithEvOrderNoTOResp = !ViewConfigurations.useSoonViewWhenTimeFilterIsChanged ?
        this.eventsProvider.getEventsStartingSoon(this.isLive, sportId, page, ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay])
        : this.eventsProvider.getEventsWithCompetitionsForSport(this.isLive, sportId, page, dates.dateFrom, dates.dateTo, eventMappingTypes);

      return forkJoin([betTypeShowTypesResp, cmpAndBtGroupsWithEvOrderNoTOResp]).pipe(
        switchMap((responses) => {
          const betTypeShowTypes = responses[0];
          const cmpAndBtGroupsWithEvOrderNoTO = responses[1];
          this.mapAndAddEventsFromCompetitionsAndBetTypeGroupsWithEventOrderNo(sportId, cmpAndBtGroupsWithEvOrderNoTO, betTypeShowTypes, languageCulture, dateFormat);
          return of(this.getEventsGroupForSport(sportId, ViewConfigurations.useSoonViewWhenTimeFilterIsChanged));
        })
      );
    } else {
      return of(this.getEventsGroupForSport(sportId, ViewConfigurations.useSoonViewWhenTimeFilterIsChanged));
    }
  }

  getEventsGroupForMostPopularEvents(sportId: number, clearData: boolean, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions): Observable<IEventsGroupComponentViewModel> {
    if (clearData) {
      this.clearEventsData();
    }

    if (clearData) {
      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const cmpAndBtGroupsWithEvOrderNoTOResp = this.eventsProvider.getMostPopularEvents(this.isLive, sportId, ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]);

      return forkJoin([betTypeShowTypesResp, cmpAndBtGroupsWithEvOrderNoTOResp]).pipe(
        switchMap((responses) => {
          const betTypeShowTypes = responses[0];
          const cmpAndBtGroupsWithEvOrderNoTO = responses[1];
          this.mapAndAddEventsFromCompetitionsAndBetTypeGroupsWithEventOrderNo(sportId, cmpAndBtGroupsWithEvOrderNoTO, betTypeShowTypes, languageCulture, dateFormat);
          return of(this.getEventsGroupForSport(sportId, false));
        })
      );
    } else {
      return of(this.getEventsGroupForSport(sportId, false));
    }
  }

  mapAndAddEventsFromCompetitionsAndBetTypeGroupsWithEventOrderNo(
    sportId: number,
    cmpAndBtGroupsWithEvOrderNoTO: ICompetitionsAndBetTypeGroupsWithEventOrderNoTO,
    betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType },
    languageCulture: string,
    dateFormat: Intl.DateTimeFormatOptions) {

    if (!this.betTypeGroupsForHierarchy[+HierarchyType.Sport]) {
      this.betTypeGroupsForHierarchy[+HierarchyType.Sport] = { betTypeGroupIds: {} };

    }

    let c = 0;
    if (!cmpAndBtGroupsWithEvOrderNoTO.groups) {
      cmpAndBtGroupsWithEvOrderNoTO.groups = [];
    }
    for (const groupTO of cmpAndBtGroupsWithEvOrderNoTO.groups) {
      c++;
      const betTypeGroup = this.modelMapper.mapBetTypeGroup(groupTO, betTypeShowTypes);

      if (!this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId]) {
        this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId] = [];
      }

      if (!this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId].includes(betTypeGroup.id)) {
        this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId].push(betTypeGroup.id);
      }
      this.betTypeGroups[betTypeGroup.id] = betTypeGroup;

      // add only first group
      if (c === 1) {
        if (!this.betGroupIdsForLoadedBetsInSport[sportId]) {
          this.betGroupIdsForLoadedBetsInSport[sportId] = [];
        }
        this.betGroupIdsForLoadedBetsInSport[sportId].push(groupTO.id);
      }
    }

    for (const competitionTO of cmpAndBtGroupsWithEvOrderNoTO.competitions) {
      for (const eventTO of competitionTO.events) {
        if (!this.events[eventTO.competitionId]) {
          this.events[eventTO.competitionId] = {};
        }

        const event: EventVM = this.modelMapper.mapEventFromV2(
          eventTO,
          languageCulture,
          this.utilityService.eventsDateToStringFormat,
          this.userEventsForNotifications.includes(eventTO.id),
          cmpAndBtGroupsWithEvOrderNoTO.sportName,
          competitionTO.regionName,
          competitionTO.competitionName,
          (cmpAndBtGroupsWithEvOrderNoTO.eventOrderNumbers && cmpAndBtGroupsWithEvOrderNoTO.eventOrderNumbers[eventTO.id]) ? cmpAndBtGroupsWithEvOrderNoTO.eventOrderNumbers[eventTO.id] : -1);
        this.events[eventTO.competitionId][eventTO.id] = event;

        this.mapAndAddBetsToCacheAndGetPlayableCount(eventTO.bets, true, betTypeShowTypes, event);

      }
    }
  }



  mapAndAddPMEventsToCache(eventsAndGroupsConfigurations: IEventsAndGroupsConfigurationsTO, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }, hierarchyId: number, hierarchyTypeForBetTypeGroups: HierarchyType, sportId?: number, createSpecialRegionsFromSport: boolean = false) {
    if (!eventsAndGroupsConfigurations) {
      return;
    }

    if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups]) {
      this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups] = { betTypeGroupIds: {} };
    }

    for (const groupsConfiguration of eventsAndGroupsConfigurations.groupsConfigurations) {
      if (hierarchyTypeForBetTypeGroups === HierarchyType.Competition) {
        this.addEventGroupsForCompetitions(groupsConfiguration, hierarchyTypeForBetTypeGroups, betTypeShowTypes);
      } else {
        // for sport or region
        let c = 0;
        for (const groupTO of groupsConfiguration.groups) {
          c++;
          const betTypeGroup = this.modelMapper.mapBetTypeGroup(groupTO, betTypeShowTypes);
          if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[hierarchyId]) {
            this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[hierarchyId] = [];
          }

          if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[hierarchyId].includes(betTypeGroup.id)) {
            this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[hierarchyId].push(betTypeGroup.id);
          }
          this.betTypeGroups[betTypeGroup.id] = betTypeGroup;

          // add only first group of competition as region config if not specials (for specials go to server for configuration)
          if (c === 1) {
            if (hierarchyTypeForBetTypeGroups === HierarchyType.Region && sportId !== environment.specialsSportId) {
              if (!this.betGroupIdsForLoadedBetsInRegion[hierarchyId]) {
                this.betGroupIdsForLoadedBetsInRegion[hierarchyId] = [];
              }
              this.betGroupIdsForLoadedBetsInRegion[hierarchyId].push(groupTO.id);
              // also add al groups for competition configs
              this.addEventGroupsForCompetitions(groupsConfiguration, HierarchyType.Competition, betTypeShowTypes);
            } else {
              if (!this.betGroupIdsForLoadedBetsInSport[hierarchyId]) {
                this.betGroupIdsForLoadedBetsInSport[hierarchyId] = [];
              }
              this.betGroupIdsForLoadedBetsInSport[hierarchyId].push(groupTO.id);
            }
          }
        }
      }

    }
    // add sportGroup to region and competition also
    if (!eventsAndGroupsConfigurations.events) {
      return;
    }

    for (const eventTO of eventsAndGroupsConfigurations.events) {
      if (!this.events[eventTO.competitionId]) {
        this.events[eventTO.competitionId] = {};
      }

      // later ask if not s or r or c go to server for them
      const sportName = this.sports[eventTO.sportId] ? this.sports[eventTO.sportId].name : null;
      const regionName = sportName && this.regions[eventTO.sportId][eventTO.regionId] ? this.regions[eventTO.sportId][eventTO.regionId].name : null;
      const competitionName = regionName && this.competitions[eventTO.regionId][eventTO.competitionId] ? this.competitions[eventTO.regionId][eventTO.competitionId].name : null;
      // need to await for spottree to be loaded
      const event: EventVM = this.modelMapper.mapEventFromV2(
        eventTO,
        languageCulture,
        this.utilityService.eventsDateToStringFormat,
        this.userEventsForNotifications.includes(eventTO.id),
        sportName,
        regionName,
        competitionName);
      this.events[eventTO.competitionId][eventTO.id] = event;


      this.mapAndAddBetsToCacheAndGetPlayableCount(eventTO.bets, true, betTypeShowTypes, event);

    }

  }

  private getEventsCountForSport(sportId): number {
    let eventsCount = 0;
    if (!this.regions[sportId]) {
      return 0;
    }

    for (const regionId of Object.keys(this.regions[sportId])) {
      eventsCount += this.getEventsCountForRegion(+regionId);
    }
    return eventsCount;
  }

  private getEventsCountForRegion(regionId): number {
    let eventsCount = 0;
    if (!this.competitions[regionId]) {
      return 0;
    }

    for (const competitionId of Object.keys(this.competitions[regionId])) {
      eventsCount += this.getEventsCountForCompetition(+competitionId);
    }
    return eventsCount;
  }

  private getEventsCountForCompetition(competitionId): number {
    if (!this.events[competitionId]) {
      return 0;
    }

    return Object.keys(this.events[competitionId]).length;
  }

  addEventGroupsForCompetitions(groupsConfiguration: IGroupsForCompetitionsTO, hierarchyTypeForBetTypeGroups: HierarchyType, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }) {
    if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups]) {
      this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups] = { betTypeGroupIds: {} };
    }
    for (const competitionId of groupsConfiguration.competitions) {
      if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[competitionId]) {
        this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[competitionId] = [];
      }

      let c = 0;
      for (const groupTO of groupsConfiguration.groups) {
        c++;
        const betTypeGroup = this.modelMapper.mapBetTypeGroup(groupTO, betTypeShowTypes);
        if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[competitionId]) {
          this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[competitionId] = [];
        }

        if (!this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[competitionId].includes(betTypeGroup.id)) {

          this.betTypeGroupsForHierarchy[+hierarchyTypeForBetTypeGroups].betTypeGroupIds[competitionId].push(betTypeGroup.id);
        }
        this.betTypeGroups[betTypeGroup.id] = betTypeGroup;

        // add only first group
        if (c === 1) {
          if (!this.betGroupIdsForLoadedBetsInCompetition[competitionId]) {
            this.betGroupIdsForLoadedBetsInCompetition[competitionId] = [];
          }
          this.betGroupIdsForLoadedBetsInCompetition[competitionId].push(groupTO.id);
        }
      }
    }
  }

  private getEventGroupsBySRCIdsAsync(sportId?: number, regionId?: number, competitionId?: number, specialOfferType?: SpecialOfferType): Observable<IEventsGroupComponentViewModel[]> {
    if (this.sportTreeObservable) {
      return this.sportTreeObservable.pipe(switchMap(x => of(this.getEventGroupsBySRCIds(sportId, regionId, competitionId, specialOfferType))));
    } else {
      return of(this.getEventGroupsBySRCIds(sportId, regionId, competitionId, specialOfferType));
    }
  }

  private getEventGroupsBySRCIds(sportId?: number, regionId?: number, competitionId?: number, specialOfferType?: SpecialOfferType): IEventsGroupComponentViewModel[] {
    if (specialOfferType) {
      return [this.getEventGroupForSpecialEventsSport(specialOfferType, sportId)];
    } else if (competitionId) {
      return [this.getEventGroupForCompetition(sportId, regionId, competitionId)];

    } else if (regionId) {

      return this.getEventGroupsForRegion(sportId, regionId);

    } else if (sportId) {

      if (!this.regions[sportId]) {
        return [];
      }
      return this.getEventGroupsForSport(sportId);

    }
  }

  private getEventGroupForSpecialEventsSport(specialOfferType: SpecialOfferType, sportId: number): IEventsGroupComponentViewModel {
    const eventGroup: IEventsGroupComponentViewModel = {
      events: [],
      betTypeGroups: [],
      sportName: null,
      regionName: null,
      competitionName: null,
      sportId: null,
      regionId: null,
      competitionId: null,
      orderNo: -1,
      specialOfferType
    };

    if (this.sports[sportId]) {
      eventGroup.competitionName = this.sports[sportId].name;
      eventGroup.competitionId = sportId;
      eventGroup.sportName = this.sports[sportId].name;
      eventGroup.sportId = this.sports[sportId].id;
      eventGroup.orderNo = this.sports[sportId].orderNo;
    } else {
      const specialOfferSportId = this.utilityService.getSpecialOfferSportId(specialOfferType);
      let sport = null;
      if (this.sports[specialOfferSportId]) {
        sport = this.sports[specialOfferSportId].regions.find(s => s.id === sportId);
      }
      if (sport) {
        eventGroup.competitionName = sport.name;
        eventGroup.competitionId = sportId;
        eventGroup.sportName = sport.name;
        eventGroup.sportId = sport.id;
        eventGroup.orderNo = sport.orderNo;
      }
    }

    for (const [cmpId, evDic] of Object.entries(this.events)) {
      for (const [evId, ev] of Object.entries(evDic)) {
        if (ev.sportId === sportId &&
           ((specialOfferType && ev.specialOfferType === specialOfferType) || !specialOfferType))  {
          eventGroup.events.push(ev);
        }
      }
    }

    eventGroup.events = this.utilityService.sortEventsByDateAndCode(Object.entries(eventGroup.events).map(([k, v]) => v));


    if (this.betTypeGroupsForHierarchy[+HierarchyType.Sport] &&
      this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId]) {
      for (const betTypeGroupId of this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId]) {
        if (this.betTypeGroups[betTypeGroupId]) {
          eventGroup.betTypeGroups.push(this.betTypeGroups[betTypeGroupId]);
        }
      }
    }

    return eventGroup;
  }

  private getEventsGroupForSport(sportId: number, orderEventsByDateAndCode: boolean = true): IEventsGroupComponentViewModel {
    const eventGroup: IEventsGroupComponentViewModel = {
      events: [],
      betTypeGroups: [],
      sportName: null,
      regionName: null,
      competitionName: null,
      sportId,
      regionId: null,
      competitionId: null,
      orderNo: 1,
      specialOfferType: null
    };

    let i = 0;
    for (const cmpId of Object.keys(this.events)) {
      for (const evId of Object.keys(this.events[cmpId])) {
        if (this.events[cmpId][evId].sportId === sportId) {
          if (i === 0) {
            eventGroup.sportName = this.events[cmpId][evId].sportName;
          }
          eventGroup.events.push(this.events[cmpId][evId]);
          i++;
        }
      }
    }


    eventGroup.events = orderEventsByDateAndCode ? this.utilityService.sortEventsByDateAndCode(eventGroup.events) : this.sortByOrderNo(eventGroup.events);

    if (this.betTypeGroupsForHierarchy[+HierarchyType.Sport] &&
      this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId]) {
      for (const betTypeGroupId of this.betTypeGroupsForHierarchy[+HierarchyType.Sport].betTypeGroupIds[sportId]) {
        if (this.betTypeGroups[betTypeGroupId]) {
          eventGroup.betTypeGroups.push(this.betTypeGroups[betTypeGroupId]);
        }
      }
    }

    return eventGroup;
  }

  private getEventGroupsForSport(sportId: number): IEventsGroupComponentViewModel[] {
    let eventGroups: IEventsGroupComponentViewModel[] = [];

    if (!this.regions[sportId]) {
      return [];
    }
    for (const key of Object.keys(this.regions[sportId])) {
      eventGroups = eventGroups.concat(this.getEventGroupsForRegion(sportId, +key));
    }

    return eventGroups;
  }

  private getEventGroupsForRegion(sportId: number, regionId: number, mergeCompetitionGroupsInSingleGroup: boolean = true): IEventsGroupComponentViewModel[] {
    if (!mergeCompetitionGroupsInSingleGroup) {
      if (!this.competitions[regionId]) {
        return [];
      }
      return Object.entries(this.competitions[regionId]).map(([k, v]) => this.getEventGroupForCompetition(sportId, regionId, v.id));
    } else {
      if (!this.regions[sportId] || !this.regions[sportId][regionId]) {
        return [];
      }
      const eventGroup: IEventsGroupComponentViewModel = {
        events: [],
        betTypeGroups: [],
        sportName: this.sports[sportId] ? this.sports[sportId].name : null,
        regionName: this.regions[sportId][regionId].name,
        competitionName: null,
        sportId: this.regions[sportId][regionId].sportId,
        regionId: this.regions[sportId][regionId].id,
        competitionId: null,
        orderNo: this.regions[sportId][regionId].orderNo,
        specialOfferType: null
      };

      if (this.regions[sportId] && this.regions[sportId][regionId]) {
        for (const competition of this.regions[sportId][regionId].competitions) {

          if (this.events[competition.id]) {
            eventGroup.events = eventGroup.events.concat(this.utilityService.sortEventsByDateAndCode(Object.entries(this.events[competition.id]).map(([k, v]) => v)));
          }
        }
      }

      if (this.betTypeGroupsForHierarchy[+HierarchyType.Region] &&
        this.betTypeGroupsForHierarchy[+HierarchyType.Region].betTypeGroupIds[regionId]) {
        for (const betTypeGroupId of this.betTypeGroupsForHierarchy[+HierarchyType.Region].betTypeGroupIds[regionId]) {
          if (this.betTypeGroups[betTypeGroupId]) {
            eventGroup.betTypeGroups.push(this.betTypeGroups[betTypeGroupId]);
          }
        }
      }

      return [eventGroup];
    }
  }

  private getEventGroupForCompetition(sportId: number, regionId: number, competitionId: number): IEventsGroupComponentViewModel {
    const eventGroup: IEventsGroupComponentViewModel = {
      events: [],
      betTypeGroups: [],
      sportName: null,
      regionName: null,
      competitionName: null,
      sportId: null,
      regionId: null,
      competitionId: null,
      orderNo: -1,
      specialOfferType: null
    };

    if (this.competitions[regionId] && this.competitions[regionId][competitionId]) {
      eventGroup.competitionName = this.competitions[regionId][competitionId].name;
      eventGroup.competitionId = competitionId;
      eventGroup.sportName = this.competitions[regionId][competitionId].sportName;
      eventGroup.regionName = this.competitions[regionId][competitionId].regionName;
      eventGroup.sportId = this.competitions[regionId][competitionId].sportId;
      eventGroup.regionId = this.competitions[regionId][competitionId].regionId;
      eventGroup.orderNo = this.competitions[regionId][competitionId].orderNo;
    }

    if (this.events[competitionId]) {
      eventGroup.events = this.utilityService.sortEventsByDateAndCode(Object.entries(this.events[competitionId]).map(([k, v]) => v));
      if (!ViewConfigurations.showSpecialEventsInStandardOffer) {
        eventGroup.events = eventGroup.events.filter(ev => ev.specialOfferType !== SpecialOfferType.SuperBet);
      }
    }

    if (this.betTypeGroupsForHierarchy[+HierarchyType.Competition] &&
      this.betTypeGroupsForHierarchy[+HierarchyType.Competition].betTypeGroupIds[competitionId]) {
      for (const betTypeGroupId of this.betTypeGroupsForHierarchy[+HierarchyType.Competition].betTypeGroupIds[competitionId]) {
        if (this.betTypeGroups[betTypeGroupId]) {
          eventGroup.betTypeGroups.push(this.betTypeGroups[betTypeGroupId]);
        }
      }
    }

    return eventGroup;
  }

  public getPMSportsTreeForFilter(timeFilter: TimeFilter, forceGetFromServer: boolean = false): Observable<ISport[]> {
    if (timeFilter === TimeFilter.Live) {
      return of([]);
    }
    if (timeFilter !== this.timeFilterForSports || forceGetFromServer) {
      this.clearSportsData();
      this.timeFilterForSports = timeFilter;
      const dates = this.utilityService.getDateFromTo(false, this.timeFilterForSports);

      return this.getSportsFromServerAndAddToCache(dates.dateFrom, dates.dateTo, this.isLive, false, false);
    } else {
      return of(this.mapSportsToTree());
    }
  }

  private getSportsFromServerAndAddToCache(dateFrom: Date, dateTo: Date, isLive: boolean, updateSelections: boolean, filterSportsOnUpdate: boolean): Observable<ISport[]> {
    const responseSportTree = this.sportsProvider.getSports(dateFrom, dateTo, isLive, ViewConfigurations.showSpecialEventsInStandardOffer ? null : [EventMappingType.StandardEvent, EventMappingType.EventOfDay]);
    const responseSpecialOfferButtons = this.sportsProvider.getSpecialOfferButtons(dateFrom, dateTo);
    if (!this.sportTreeObservable) {
      this.sportTreeObservable = forkJoin([responseSportTree, responseSpecialOfferButtons]).pipe(
        switchMap((responses) => {
          let selectedSport: ISport = null;
          let selectedRegion: IRegion = null;
          let selectedCompetition: ICompetition = null;
          const newSports: number[] = [];
          const newRegions: number[] = [];
          const newCompetitions: number[] = [];
          const newSpecialOfferSports: number[] = [];
          if (updateSelections) {
            if (this.sports[this.storage.srcSelectionIdsPrematch.sId]) {
              selectedSport = this.sports[this.storage.srcSelectionIdsPrematch.sId];

              if (this.regions[this.storage.srcSelectionIdsPrematch.sId] && this.regions[this.storage.srcSelectionIdsPrematch.sId][this.storage.srcSelectionIdsPrematch.rId]) {
                selectedRegion = this.regions[this.storage.srcSelectionIdsPrematch.sId][this.storage.srcSelectionIdsPrematch.rId];

                if (this.competitions[this.storage.srcSelectionIdsPrematch.rId] && this.competitions[this.storage.srcSelectionIdsPrematch.rId][this.storage.srcSelectionIdsPrematch.cId]) {
                  selectedCompetition = this.competitions[this.storage.srcSelectionIdsPrematch.rId][this.storage.srcSelectionIdsPrematch.cId];
                }
              }
            }
          }
          let i = 0;
          for (const sportTO of responses[0]) {
            i++;
            const sport = this.modelMapper.mapSport(sportTO, i * 2);
            if (selectedSport?.id === sport.id) {
              sport.isSelected = selectedSport?.isSelected || this.sports[sport.id]?.isSelected;
              sport.showRegions = selectedSport?.showRegions || this.sports[sport.id]?.showRegions;
            } else if (this.sports[sport.id]) {
              sport.isSelected = this.sports[sport.id]?.isSelected;
              sport.showRegions = this.sports[sport.id]?.showRegions;
            }

            if (filterSportsOnUpdate) {
              newSports.push(sport.id);
            }

            this.sports[sport.id] = sport;
            this.regions[sport.id] = {};
            let j = 0;
            for (const regionTO of sportTO.regions) {
              j++;
              const region = this.modelMapper.mapRegion(regionTO, sport.name, i * 100 + j);

              if (selectedRegion && selectedRegion.id === region.id) {
                region.isSelected = selectedRegion.isSelected;
                region.showCompetitions = selectedRegion.showCompetitions;
              }

              if (filterSportsOnUpdate) {
                newRegions.push(region.id);
              }


              this.regions[region.sportId][region.id] = region;
              this.competitions[region.id] = {};
              let k = 0;
              for (const competitionTO of regionTO.competitions) {
                k++;
                this.competitions[region.id][competitionTO.id] = this.modelMapper.mapCompetition(competitionTO, sport.name, region.name, region.orderNo * 100 + k);
                if (competitionTO.id === environment.higlightedLeagueId) {
                  const higlightedRegion: IRegion = {
                    competitions: [],
                    eventsCount: this.competitions[region.id][competitionTO.id].eventsCount,
                    id: -9999,
                    isSelected: false,
                    name: this.competitions[region.id][competitionTO.id].name,
                    shortName: 'ABA',
                    showCompetitions: false,
                    sportId: this.competitions[region.id][competitionTO.id].sportId,
                    orderNo: -9999
                  };
                  this.regions[higlightedRegion.sportId][higlightedRegion.id] = higlightedRegion;
                  newRegions.push(higlightedRegion.id);
                  this.competitions[-9999] = {};
                }
                if (filterSportsOnUpdate) {
                  newCompetitions.push(competitionTO.id);
                }

                if (selectedCompetition && selectedCompetition.id === this.competitions[region.id][competitionTO.id].id) {
                  this.competitions[region.id][competitionTO.id].isSelected = selectedCompetition.isSelected;
                  this.competitions[region.id][competitionTO.id].isExpanded = selectedCompetition.isExpanded;
                }
              }
            }
          }

          for (const specialOfferButton of responses[1]) {
            const sport = this.modelMapper.mapSportFromSpecialOfferButtonTO(specialOfferButton, this.utilityService.getSpecialOfferSportId(specialOfferButton.id));
            if (selectedSport && selectedSport.id === sport.id) {
              sport.isSelected = selectedSport.isSelected;
              sport.showRegions = selectedSport.showRegions;
            }
            this.sports[sport.id] = sport;
            if (filterSportsOnUpdate) {
              newSports.push(sport.id);
            }
            for (const region of sport.regions) {
              if (!this.specialOfferSports[sport.specialOfferType]) {
                this.specialOfferSports[sport.specialOfferType] = {};
              }
              this.specialOfferSports[sport.specialOfferType][region.id] = region;
              if (filterSportsOnUpdate) {
                newSpecialOfferSports.push(region.id);
              }
            }

            if (sport.id === this.utilityService.getSpecialOfferSportId(SpecialOfferType.Outrights)) {
              const specials = this.sports[environment.specialsSportId];
              if (ViewConfigurations.showOutrightsAtEnd) {
                sport.orderNo = 999999;
              } else {
                if (specials) {
                  sport.orderNo = specials.orderNo - 1;
                }
              }
            }
          }
          if (filterSportsOnUpdate) {
            this.filterSports(newSports, newRegions, newCompetitions, newSpecialOfferSports);
          }
          this.cacheChangesService.subscribeForAllChangesPm();
          this.sportTreeObservable = null;
          return of(this.mapSportsToTree());
        })
      );

    }

    return this.sportTreeObservable;

    // return this.sportsProvider.getSpecialOfferButtons(dateFrom, dateTo).pipe(
    //   switchMap((specialOfferButtons) => {
    //     for (const specialOfferButton of specialOfferButtons) {
    //       const sport = this.modelMapper.mapSportFromSpecialOfferButtonTO(specialOfferButton, this.utilityService.getSpecialOfferSportId(specialOfferButton.id));
    //       this.sports[sport.id] = sport;
    //     }
    //     return of(this.mapSportsToTree());
    //   }));
  }

  private filterSports(newSports: number[], newRegions: number[], newCompetitions: number[], newSpecialOfferSports: number[]) {
    const sporttIds = Object.keys(this.sports);

    for (const sportid of sporttIds) {
      if (!newSports.includes(+sportid)) {
        delete this.sports[+sportid];
      }

      if (+sportid > 0 && this.regions[+sportid]) {
        const regionIds = Object.keys(this.regions[+sportid]);
        for (const regionId of regionIds) {
          if (!newRegions.includes(+regionId)) {
            delete this.regions[+sportid][+regionId];
          }
          if (this.competitions[+regionId]) {
            const competitionIds = Object.keys(this.competitions[+regionId]);
            for (const competitionId of competitionIds) {
              if (!newCompetitions.includes(+competitionId)) {
                delete this.competitions[+regionId][+competitionId];
              }
            }
          }
        }
      }

      if (+sportid < 0 && this.specialOfferSports[+sportid]) {
        const specialOfferSportIds = Object.keys(this.specialOfferSports[+sportid]);
        for (const specialOfferSportId of specialOfferSportIds) {
          if (!newSpecialOfferSports.includes(+specialOfferSportId)) {
            delete this.specialOfferSports[+sportid][+specialOfferSportId];
          }
        }
      }
    }
  }

  public mapSportsToTree(specialOfferType: SpecialOfferType[] = []): ISport[] {
    const sports: ISport[] = this.sortByOrderNo(Object.entries(this.sports).map(([key, sport]) => {
      if (!this.regions[sport.id]) {
        sport.regions = [];
        if (sport.specialOfferType && this.specialOfferSports[sport.specialOfferType]) {
          sport.regions = this.sortByOrderNo(Object.entries(this.specialOfferSports[sport.specialOfferType]).map(([key, region]) => region));
        }
      } else {
        sport.regions = this.sortByOrderNo(Object.entries(this.regions[sport.id]).map(([key, region]) => {
          region.competitions = this.sortByOrderNo(Object.entries(this.competitions[region.id]).map(([key, competition]) => competition));
          return region;
        }));
      }
      return sport;
    }));
    if (specialOfferType.length > 0) {
      return sports.filter(s => specialOfferType.includes(s.specialOfferType));
    } else {
      return sports;
    }
  }

  public getLiveSportsWithCompetitions(): ISportWithCompetitions[] {
    return this.mapSportsToSportsWithCompetitions();
  }

  public getCompetitionsForSport(sportId: number): ICompetition[] {
    if (!this.regions[sportId]) {
      return [];
    }

    const regionIds = Object.keys(this.regions[sportId]);
    let competitionsList: ICompetition[] = [];
    for (const regionId of regionIds) {
      if (!this.competitions[+regionId]) {
        continue;
      }
      competitionsList = competitionsList.concat(Object.entries(this.competitions[+regionId]).map(([k, v]) => v));
    }
    return this.sortByFavouriteOrderNo(this.sortByOrderNo(competitionsList));
  }


  public getEventsForSport(sportId): EventVM[] {
    let events: EventVM[] = [];

    if (!this.regions[sportId]) {
      return [];
    }
    for (const key of Object.keys(this.regions[sportId])) {
      events = events.concat(this.getEventsForRegion(+key));
    }

    return this.sortEventsByFavoriteCompetitionOrder(this.utilityService.sortEventsByDateAndCode(events));
  }

  public getEventsOrderedBySrc(eventSrcs: IEventSrc[]): { sportsWithEvents: ISportWithEventsList[]; eventsCount: number } {
    const events: EventVM[] = [];
    const sportsWithEvents: ISportWithEventsList[] = [];
    for (const eventSrc of eventSrcs) {
      if (this.events[eventSrc.competitionId] && this.events[eventSrc.competitionId][eventSrc.eventId]) {
        events.push(this.events[eventSrc.competitionId][eventSrc.eventId]);
      }
    }
    const totalEventsCount = events.length;
    const grouped: { [sportId: number]: EventVM[] } = events.reduce((hash, obj) => ({ ...hash, [obj.sportId]: (hash[obj.sportId] || []).concat(obj) }), {});
    for (const sportId of Object.keys(grouped)) {
      if (!this.sports[+sportId]) {
        continue;
      }
      const sport = {
        sport: this.sports[+sportId],
        events: this.utilityService.sortEventsByDateAndCode(grouped[+sportId]),
        orderNo: this.sports[+sportId].orderNo,
        eventsCount: 0
      };
      sport.eventsCount = sport.events.length;
      this.favoriteEventsCount = sport.eventsCount;
      sportsWithEvents.push(sport);

    }
    return { sportsWithEvents: this.sortByOrderNo(sportsWithEvents), eventsCount: totalEventsCount };
  }

  public getEventsForRegion(regionId: number): EventVM[] {
    let events: EventVM[] = [];
    if (!this.competitions[regionId]) {
      return [];
    }

    for (const key of Object.keys(this.competitions[regionId])) {
      events = events.concat(this.getEventsForCompetition(+key));
    }
    return events;
  }

  public getEventsForCompetition(competitionId: number): EventVM[] {
    if (!this.events[competitionId]) {
      return [];
    }

    return this.utilityService.sortEventsByDateAndCode(Object.entries(this.events[competitionId]).map(([k, v]) => v));
  }

  private mapSportsToSportsWithCompetitions(): ISportWithCompetitions[] {
    const sportsWitCompetitions = [];
    const sportsKVList = Object.entries(this.sports);
    for (const [key, sport] of sportsKVList) {
      const sportWithCompetitions = this.modelMapper.createSportWithCompetitions(sport);
      if (!this.regions[sport.id]) {
        continue;
      }

      const regionsKVList = Object.entries(this.regions[sport.id]);
      for (const [key, region] of regionsKVList) {
        if (!this.competitions[region.id]) {
          continue;
        }

        const competitionsKVList = Object.entries(this.competitions[region.id]);
        for (const [key, competition] of competitionsKVList) {
          if (!this.events[competition.id]) {
            continue;
          }

          sportWithCompetitions.competitions.push(competition);
        }
      }
      this.sortByOrderNo(sportWithCompetitions.competitions);
      sportsWitCompetitions.push(sportWithCompetitions);
    }

    this.sortByOrderNo(sportsWitCompetitions);

    return sportsWitCompetitions;
  }

  public sortByOrderNo(list: any[]): any[] {
    if (!list || list.length < 2) {
      return list;
    } else {
      list.sort((e1, e2) => {
        if (e1.orderNo > e2.orderNo) {
          return 1;
        }
        if (e1.orderNo < e2.orderNo) {
          return -1;
        }
        return 0;
      });
      return list;
    }
  }

  public sortByFavouriteOrderNo(list: any[]): any[] {
    if (!list || list.length < 2) {
      return list;
    } else {
      list.sort((e1, e2) => {
        if (!e1.liveFavouriteOrderNumber && e2.liveFavouriteOrderNumber) {
          return 1;
        }

        if (e1.liveFavouriteOrderNumber && !e2.liveFavouriteOrderNumber) {
          return -1;
        }

        if (!e1.liveFavouriteOrderNumber && !e2.liveFavouriteOrderNumber) {
          return 0;
        }

        if (e1.liveFavouriteOrderNumber > e2.liveFavouriteOrderNumber) {
          return 1;
        }
        if (e1.liveFavouriteOrderNumber < e2.liveFavouriteOrderNumber) {
          return -1;
        }
        return 0;
      });
      return list;
    }
  }

  public sortEventsByFavoriteCompetitionOrder(events: EventVM[]): EventVM[] {
    if (!events || events.length < 2) {
      return events;
    } else {
      events.sort((e1, e2) => {

        if (!this.competitions[e1.regionId][e1.competitionId].liveFavouriteOrderNumber && this.competitions[e2.regionId][e2.competitionId].liveFavouriteOrderNumber) {
          return 1;
        }

        if (this.competitions[e1.regionId][e1.competitionId].liveFavouriteOrderNumber && !this.competitions[e2.regionId][e2.competitionId].liveFavouriteOrderNumber) {
          return -1;
        }

        if (!this.competitions[e1.regionId][e1.competitionId].liveFavouriteOrderNumber && !this.competitions[e2.regionId][e2.competitionId].liveFavouriteOrderNumber) {
          return 0;
        }

        if (this.competitions[e1.regionId][e1.competitionId].liveFavouriteOrderNumber > this.competitions[e2.regionId][e2.competitionId].liveFavouriteOrderNumber) {
          return 1;
        }

        if (this.competitions[e1.regionId][e1.competitionId].liveFavouriteOrderNumber < this.competitions[e2.regionId][e2.competitionId].liveFavouriteOrderNumber) {
          return -1;
        }

        if (e1.dateTime > e2.dateTime) {
          return 1;
        }
        if (e1.dateTime < e2.dateTime) {
          return -1;
        }

        return 0;
      });
      return events;
    }
  }

  // send first n or betTypeIds
  private async getBetsForBetTypeGroupingTemplateItems(eventId: number, betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[]): Promise<IBetsAndOutcomesForBetTypeGroup> {
    const betsAndOutcomes: IBetsAndOutcomesForBetTypeGroup = {
      bets: {},
      betOutcomes: {},
      sbvsForBetTypes: {},
    };

    const betTypeShowTypes = await this.settingsService.getBetTypeShowTypes().toPromise();
    // most balance bet is fixed, if it will be changable, than exact and all wont work this way- all should be changed
    for (const bgtgi of betTypeGroupingTemplateItems) {
      if (!this.bets[eventId] || !this.bets[eventId][bgtgi.betTypeId]) {
        continue;
      }

      const betsListForBetType = []; // Object.entries(this.bets[eventId][betTypeSelection.betTypeId]).map(([k, v]) => v);
      const betOutcomesForBets: { [betId: number]: IBetOutcome[] } = {};

      for (const [k, bet] of Object.entries(this.bets[eventId][bgtgi.betTypeId])) {
        betsListForBetType.push(bet);
        if (bet.sbv && bet.isPlayable && bet.isInOffer) {
          if (!betsAndOutcomes.sbvsForBetTypes[bgtgi.betTypeId]) {
            betsAndOutcomes.sbvsForBetTypes[bgtgi.betTypeId] = [];
          }
          betsAndOutcomes.sbvsForBetTypes[bgtgi.betTypeId].push({ betId: bet.id, sbv: bet.sbv });
        }
        if (bgtgi.sbvSelectionType === SBVSelectionType.MostBalanced && this.betOutcomes[bet.id]) {
          betOutcomesForBets[bet.id] = [];
          for (const [k, bod] of Object.entries(this.betOutcomes[bet.id])) {
            Object.entries(bod).map(([k, v]) => betOutcomesForBets[bet.id].push(v));
          }
        }
      }

      if (betsAndOutcomes.sbvsForBetTypes[bgtgi.betTypeId]) {
        betsAndOutcomes.sbvsForBetTypes[bgtgi.betTypeId].sort((a, b) => (a.sbv > b.sbv) ? 1 : ((b.sbv > a.sbv) ? -1 : 0));
      }

      const betTypeShowType: IBetTypeShowType = betTypeShowTypes[bgtgi.betTypeId];
      this.utilityService.sortBetsByOrderingType(betsListForBetType, betTypeShowType ? betTypeShowType.betOrderingType : BetOrderingType.NoOrdering);

      switch (bgtgi.sbvSelectionType) {
        case SBVSelectionType.All:
          betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType.find(b => b.isInOffer && b.isPlayable);
          if (!betsAndOutcomes.bets[bgtgi.betTypeId]) {
            betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType[0];
          }
          break;
        case SBVSelectionType.MostBalanced:
          if (bgtgi.betTypeOutcomes.length !== 2) {
            betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType.find(b => b.isInOffer && b.isPlayable);
            if (!betsAndOutcomes.bets[bgtgi.betTypeId]) {
              betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType[0];
            }
          } else {
            const mostBalancedIndex = this.utilityService.getMostBalancedBetIndex(betsListForBetType, betOutcomesForBets);
            if (mostBalancedIndex > -1) {
              betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType[mostBalancedIndex];
            } else {
              betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType[0];
            }
          }
          break;
        case SBVSelectionType.Exact:
          betsAndOutcomes.bets[bgtgi.betTypeId] = betsListForBetType.find(b => b.sbv === bgtgi.sbvExactValue);
          break;
      }
      if (betsAndOutcomes.bets[bgtgi.betTypeId] && this.betOutcomes[betsAndOutcomes.bets[bgtgi.betTypeId].id]) {
        betsAndOutcomes.betOutcomes[betsAndOutcomes.bets[bgtgi.betTypeId].id] = {};
        if (bgtgi.betTypeOutcomes) {
          for (const bto of bgtgi.betTypeOutcomes) {

            betsAndOutcomes.betOutcomes[betsAndOutcomes.bets[bgtgi.betTypeId].id][bto.id] = this.betOutcomes[betsAndOutcomes.bets[bgtgi.betTypeId].id][bto.id] ? Object.entries(this.betOutcomes[betsAndOutcomes.bets[bgtgi.betTypeId].id][bto.id]).map(([k, v]) => v) : [];
          }
        }
      }
    }
    return betsAndOutcomes;
  }


  public getBetsAndOutcomesForBetTypeSelections(eventId: number, betTypeSelections: IBetTypeSelection[]): IBetsAndOutcomesForBetTypeGroup {
    const betsAndOutcomes: IBetsAndOutcomesForBetTypeGroup = {
      bets: {},
      betOutcomes: {},
      sbvsForBetTypes: {},
    };

    for (const betTypeSelection of betTypeSelections) {
      if (!this.bets[eventId] || !this.bets[eventId][betTypeSelection.betTypeId]) {
        continue;
      }

      const betsListForBetType = []; // Object.entries(this.bets[eventId][betTypeSelection.betTypeId]).map(([k, v]) => v);
      const betOutcomesForBets: { [betId: number]: IBetOutcome[] } = {};
      for (const [k, bet] of Object.entries(this.bets[eventId][betTypeSelection.betTypeId])) {
        betsListForBetType.push(bet);

        if (bet.sbv && bet.isPlayable && bet.isInOffer) {
          if (!betsAndOutcomes.sbvsForBetTypes[betTypeSelection.betTypeId]) {
            betsAndOutcomes.sbvsForBetTypes[betTypeSelection.betTypeId] = [];
          }
          betsAndOutcomes.sbvsForBetTypes[betTypeSelection.betTypeId].push({ betId: bet.id, sbv: bet.sbv });
        }

        if (betTypeSelection.sbvSelectionType === BetTypeSelectionSBVSelectionType.MostBalanced && this.betOutcomes[bet.id]) {
          betOutcomesForBets[bet.id] = [];
          for (const [k, bod] of Object.entries(this.betOutcomes[bet.id])) {
            Object.entries(bod).map(([k, v]) => betOutcomesForBets[bet.id].push(v));
          }
        }
      }

      if (betsAndOutcomes.sbvsForBetTypes[betTypeSelection.betTypeId]) {
        betsAndOutcomes.sbvsForBetTypes[betTypeSelection.betTypeId].sort((a, b) => (a.sbv > b.sbv) ? 1 : ((b.sbv > a.sbv) ? -1 : 0));
      }

      switch (betTypeSelection.sbvSelectionType) {
        case BetTypeSelectionSBVSelectionType.None:
          betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType.find(b => b.isInOffer && b.isPlayable);
          if (!betsAndOutcomes.bets[betTypeSelection.betTypeId]) {
            betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType[0];
          }
          break;
        case BetTypeSelectionSBVSelectionType.MostBalanced:
          if (betTypeSelection.betTypeOutcomes.length !== 2) {
            betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType.find(b => b.isInOffer && b.isPlayable);
            if (!betsAndOutcomes.bets[betTypeSelection.betTypeId]) {
              betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType[0];
            }
          } else {

            const mostBalancedIndex = this.utilityService.getMostBalancedBetIndex(betsListForBetType, betOutcomesForBets);
            if (mostBalancedIndex > -1) {
              betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType[mostBalancedIndex];
            } else {
              betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType[0];
            }
          }
          break;
        case BetTypeSelectionSBVSelectionType.Exact:
          betsAndOutcomes.bets[betTypeSelection.betTypeId] = betsListForBetType.find(b => b.sbv === betTypeSelection.sbvExactValue);
          break;
      }
      if (betsAndOutcomes.bets[betTypeSelection.betTypeId] && this.betOutcomes[betsAndOutcomes.bets[betTypeSelection.betTypeId].id]) {
        betsAndOutcomes.betOutcomes[betsAndOutcomes.bets[betTypeSelection.betTypeId].id] = {};
        for (const bto of betTypeSelection.betTypeOutcomes) {

          betsAndOutcomes.betOutcomes[betsAndOutcomes.bets[betTypeSelection.betTypeId].id][bto.id] = this.betOutcomes[betsAndOutcomes.bets[betTypeSelection.betTypeId].id][bto.id] ? Object.entries(this.betOutcomes[betsAndOutcomes.bets[betTypeSelection.betTypeId].id][bto.id]).map(([k, v]) => v) : [];
        }
      }
    }
    return betsAndOutcomes;
  }

  public getBetTypeSelectionsForSport(sportId: number): IBetTypeSelection[] {
    if (!this.betTypeSelectionsForSport[sportId]) {
      return [];
    }

    return this.betTypeSelectionsForSport[sportId];
  }

  public get betTypeSelections(): { [sportId: number]: IBetTypeSelection[] } {
    return this.betTypeSelectionsForSport;
  }

  // used as competition id is sent
  public getBetsAndOutcomesForBetTypeGroupForCompetition(betTypeGroup: IBetTypeGroup, sportId: number, regionId: number, competitionId: number, events: EventVM[], betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[]): Observable<{ [eventId: number]: IBetsAndOutcomesForBetTypeGroup }> {
    let notInCache = true;
    const eventIds = events.map((e) => e.id);

    if (this.betGroupIdsForLoadedBetsInCompetition[competitionId] && this.betGroupIdsForLoadedBetsInCompetition[competitionId].includes(betTypeGroup.id)) {
      notInCache = false;
    } else if (this.betGroupIdsForLoadedBetsInRegion[regionId] && this.betGroupIdsForLoadedBetsInRegion[regionId].includes(betTypeGroup.id)) {
      if (!this.betGroupIdsForLoadedBetsInCompetition[competitionId]) {
        this.betGroupIdsForLoadedBetsInCompetition[competitionId] = [];
      }
      this.betGroupIdsForLoadedBetsInCompetition[competitionId].push(betTypeGroup.id);
      notInCache = false;
    } else if (this.betGroupIdsForLoadedBetsInSport[sportId] && this.betGroupIdsForLoadedBetsInSport[sportId].includes(betTypeGroup.id)) {
      if (!this.betGroupIdsForLoadedBetsInCompetition[competitionId]) {
        this.betGroupIdsForLoadedBetsInCompetition[competitionId] = [];
      }
      this.betGroupIdsForLoadedBetsInCompetition[competitionId].push(betTypeGroup.id);
      notInCache = false;
    }

    if (notInCache) {
      if (eventIds.length < 1) {
        return of({});
      }
      // this check should be for sport or region or competition
      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const getBetsForGroupResp = this.eventsProvider.getBetsForGroup(sportId, regionId, competitionId, betTypeGroup.id, eventIds);

      return forkJoin([betTypeShowTypesResp, getBetsForGroupResp]).pipe(
        switchMap(async responses => {
          const betTypeShowTypes = responses[0];
          const betsForGroup = responses[1];
          if (!betsForGroup) {
            return [];
          }

          for (const betsAndEid of betsForGroup) {
            this.mapAndAddBetsToCacheAndGetPlayableCount(betsAndEid.bets, true, betTypeShowTypes, events.find(ev => ev.id === betsAndEid.eventId));
          }

          if (!this.betGroupIdsForLoadedBetsInCompetition[competitionId]) {
            this.betGroupIdsForLoadedBetsInCompetition[competitionId] = [];
          }

          this.betGroupIdsForLoadedBetsInCompetition[competitionId].push(betTypeGroup.id);


          return await this.getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds, betTypeGroupingTemplateItems);
        }));

    } else {
      return from(this.getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds, betTypeGroupingTemplateItems));
    }
  }

  public getBetsAndOutcomesForBetTypeGroupForRegion(betTypeGroup: IBetTypeGroup, sportId: number, regionId: number, events: EventVM[], betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[]): Observable<{ [eventId: number]: IBetsAndOutcomesForBetTypeGroup }> {
    let notInCache = true;
    const eventIds = events.map((e) => e.id);

    if (this.betGroupIdsForLoadedBetsInRegion[regionId] && this.betGroupIdsForLoadedBetsInRegion[regionId].includes(betTypeGroup.id)) {
      notInCache = false;
    } else if (this.betGroupIdsForLoadedBetsInRegion[regionId] && this.betGroupIdsForLoadedBetsInRegion[regionId].includes(betTypeGroup.id)) {
      if (!this.betGroupIdsForLoadedBetsInRegion[regionId]) {
        this.betGroupIdsForLoadedBetsInRegion[regionId] = [];
      }
      this.betGroupIdsForLoadedBetsInRegion[regionId].push(betTypeGroup.id);
      notInCache = false;
    } else if (this.betGroupIdsForLoadedBetsInSport[sportId] && this.betGroupIdsForLoadedBetsInSport[sportId].includes(betTypeGroup.id)) {
      if (!this.betGroupIdsForLoadedBetsInRegion[regionId]) {
        this.betGroupIdsForLoadedBetsInRegion[regionId] = [];
      }
      this.betGroupIdsForLoadedBetsInRegion[regionId].push(betTypeGroup.id);
      notInCache = false;
    }

    if (notInCache) {
      if (eventIds.length < 1) {
        return of({});
      }
      // this check should be for sport or region or competition
      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const getBetsForGroupResp = this.eventsProvider.getBetsForGroup(sportId, regionId, null, betTypeGroup.id, eventIds);

      return forkJoin([betTypeShowTypesResp, getBetsForGroupResp]).pipe(
        switchMap(async responses => {
          const betTypeShowTypes = responses[0];
          const betsForGroup = responses[1];
          if (!betsForGroup) {
            return [];
          }

          for (const betsAndEid of betsForGroup) {
            this.mapAndAddBetsToCacheAndGetPlayableCount(betsAndEid.bets, true, betTypeShowTypes, events.find(ev => ev.id === betsAndEid.eventId));
          }

          if (!this.betGroupIdsForLoadedBetsInRegion[regionId]) {
            this.betGroupIdsForLoadedBetsInRegion[regionId] = [];
          }

          this.betGroupIdsForLoadedBetsInRegion[regionId].push(betTypeGroup.id);

          return await this.getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds, betTypeGroupingTemplateItems);
        }));

    } else {
      return from(this.getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds, betTypeGroupingTemplateItems));
    }
  }

  public getBetsAndOutcomesForBetTypeGroupForSport(betTypeGroup: IBetTypeGroup, sportId: number, events: EventVM[], betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[]): Observable<{ [eventId: number]: IBetsAndOutcomesForBetTypeGroup }> {
    let notInCache = true;
    const eventIds = events.map((e) => e.id);

    if (this.betGroupIdsForLoadedBetsInSport[sportId] && this.betGroupIdsForLoadedBetsInSport[sportId].includes(betTypeGroup.id)) {
      notInCache = false;
    }

    if (notInCache) {
      // this check should be for sport or region or competition

      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const getBetsForGroupResp = this.eventsProvider.getBetsForGroup(sportId, null, null, betTypeGroup.id, eventIds);

      return forkJoin([betTypeShowTypesResp, getBetsForGroupResp]).pipe(
        switchMap(async responses => {
          const betTypeShowTypes = responses[0];
          const betsForGroup = responses[1];
          for (const betsAndEid of betsForGroup) {
            this.mapAndAddBetsToCacheAndGetPlayableCount(betsAndEid.bets, true, betTypeShowTypes, events.find(ev => ev.id === betsAndEid.eventId));
          }

          if (!this.betGroupIdsForLoadedBetsInSport[sportId]) {
            this.betGroupIdsForLoadedBetsInSport[sportId] = [];
          }

          this.betGroupIdsForLoadedBetsInSport[sportId].push(betTypeGroup.id);

          return await this.getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds, betTypeGroupingTemplateItems);
        }));

    } else {
      return from(this.getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds, betTypeGroupingTemplateItems));
    }
  }


  public getBetsAndOutcomesForBetTypeGroupingTemplateItemsOfEvent(eventId: number, betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[]): Observable<IBetsAndOutcomesForBetTypeGroup> {
    return from(this.getBetsForBetTypeGroupingTemplateItems(eventId, betTypeGroupingTemplateItems));
  }

  private async getBetsForBetTypeGroupingTemplateItemsOfEvents(eventIds: number[], betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[]): Promise<{ [eventId: number]: IBetsAndOutcomesForBetTypeGroup }> {
    const betsAndOutcomesForEvents: { [eventId: number]: IBetsAndOutcomesForBetTypeGroup } = {};
    for (const eventId of eventIds) {

      betsAndOutcomesForEvents[eventId] = await this.getBetsForBetTypeGroupingTemplateItems(eventId, betTypeGroupingTemplateItems);

    }
    return betsAndOutcomesForEvents;
  }

  private mapAndAddBetsToCacheAndGetPlayableCount<T extends IBetV2TO | IBetTO>(betsTO: T[], isV2: boolean, betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }, event: EventVM): number {
    // maybe to put this in separate event component to call for events
    let playableBetsCount = 0;
    if (!betsTO) {
      return 0;
    }

    // needed to set orderNo for bet
    const eventIds = [];
    const betTypeIdsForEvents: { [eventId: number]: number[] } = {};

    let i = 1;
    for (const betTO of betsTO) {

      if (!this.bets[betTO.eventId]) {
        this.bets[betTO.eventId] = {};
      }

      if (!eventIds.includes(betTO.eventId)) {
        eventIds.push(betTO.eventId);
        betTypeIdsForEvents[betTO.eventId] = [];
      }

      if (!betTypeIdsForEvents[betTO.eventId].includes(betTO.betTypeId)) {
        betTypeIdsForEvents[betTO.eventId].push(betTO.betTypeId);
      }

      if (!this.bets[betTO.eventId][betTO.betTypeId]) {
        this.bets[betTO.eventId][betTO.betTypeId] = {};
      }

      if (isV2) {
        this.bets[betTO.eventId][betTO.betTypeId][betTO.id] = this.modelMapper.mapBetFromV2(betTO as IBetV2TO, i, this.isLive, betTypeShowTypes[betTO.betTypeId]);
      } else {
        this.bets[betTO.eventId][betTO.betTypeId][betTO.id] = this.modelMapper.mapBet(betTO as IBetTO, i, this.isLive, false, betTypeShowTypes[betTO.betTypeId]);
      }

      if (this.bets[betTO.eventId][betTO.betTypeId][betTO.id].isPlayable) {
        playableBetsCount++;
      }

      i++;
      for (const boTO of betTO.betOutcomes) {
        if (!this.betOutcomes[boTO.betId]) {
          this.betOutcomes[boTO.betId] = {};
        }

        if (!this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId]) {
          this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId] = {};
        }
        if (isV2) {
          this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId][boTO.id] = this.modelMapper.mapBetOutcomeFromV2(boTO as IBetOutcomeV2TO, event.isLive, this.storage.isOutcomeInTicket(boTO.eventId, boTO.id));
        } else {
          this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId][boTO.id] = this.modelMapper.mapBetOutcome(boTO as IBetOutcomeTO, event.isLive, this.storage.isOutcomeInTicket(boTO.eventId, boTO.id));
        }
        if (this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId][boTO.id].isPlayable && this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId][boTO.id].isPlayable) {
          this.bets[betTO.eventId][betTO.betTypeId][betTO.id].hasPlayableOutcomes = true;
        }
        this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId][boTO.id].name = this.utilityService.getBetOutcomeNameFromBTO(this.betOutcomes[boTO.betId][boTO.betTypeOutcomeId][boTO.id], betTypeShowTypes[betTO.betTypeId], event.homeTeam, event.awayTeam, event.eventType);
      }
    }
    for (const eventId of eventIds) {
      if (!betTypeIdsForEvents[eventId]) {
        continue;
      }
      for (const betTypeId of betTypeIdsForEvents[eventId]) {
        const sortedbets = this.utilityService.sortBetsBySbvAsc(Object.entries(this.bets[eventId][betTypeId]).map(([k, v]) => v));

        for (let i = 0; i < sortedbets.length; i++) {
          sortedbets[i].orderNo = i + 1;
        }
      }
    }
    return playableBetsCount;
  }

  updateSingleBet(betFromCahche: IBet, betToUpdate: IBet) {
    betToUpdate.sbv = betFromCahche.sbv;
    betToUpdate.orderNo = betFromCahche.orderNo;
    betToUpdate.isInOffer = betFromCahche.isInOffer;
    betToUpdate.isPlayable = betFromCahche.isPlayable;
    betToUpdate.isMostBalanced = betFromCahche.isMostBalanced;
    // betToUpdate.isFinished = betFromCahche.isFinished;
    betToUpdate.isLive = betFromCahche.isLive;
    betToUpdate.cashBackEnabled = betFromCahche.cashBackEnabled;
  }

  updateSingleBetOutcome(btoFromCahche: IBetOutcome, btoToUpdate: IBetOutcome) {
    btoToUpdate.cashBackEnabled = btoFromCahche.cashBackEnabled;
    btoToUpdate.isInOffer = btoFromCahche.isInOffer;
    btoToUpdate.isLive = btoFromCahche.isLive;
    btoToUpdate.isPlayable = btoFromCahche.isPlayable;
    btoToUpdate.oldOdd = btoToUpdate.odd;
    btoToUpdate.odd = btoFromCahche.odd;
    // if (btoToUpdate.oldOdd > btoToUpdate.odd) {
    //   if (btoToUpdate.higherLowerOdd === BetOutcomeOddDifference.Lower) {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Lower2;
    //   } else {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Lower;
    //   }
    // }

    // if (btoToUpdate.oldOdd < btoToUpdate.odd) {
    //   if (btoToUpdate.higherLowerOdd === BetOutcomeOddDifference.Higher) {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Higher2;
    //   } else {
    //     btoToUpdate.higherLowerOdd = BetOutcomeOddDifference.Higher;
    //   }
    // }
    btoToUpdate.orderNo = btoFromCahche.orderNo;
    btoToUpdate.resultStatus = btoFromCahche.resultStatus;
    btoToUpdate.description = btoFromCahche.description;
  }

  public getLiveSports(sportId: number, languageCulture: string, dateFormat: Intl.DateTimeFormatOptions): Observable<ISport[]> {
    if ((sportId && !this.sports[sportId]) || Object.keys(this.sports).length < 1) {
      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const liveSportsResp = this.sportsProvider.getLiveSports(null);

      return forkJoin([betTypeShowTypesResp, liveSportsResp]).pipe(
        switchMap(async (responses) => {
          const betTypeShowTypes = responses[0];
          const sportsWithSelectionsTO = responses[1];

          const favoriteSport: ISport = {
            id: -99,
            eventsCount: 0,
            regions: [],
            name: DynamicTranslations.favoriteButtonName,
            showRegions: false,
            isSelected: false,
            orderNo: -1,
            specialOfferType: null
          };

          this.sports[-99] = favoriteSport;
          await this.mapLiveSportsAndEventsAndAddToCache(betTypeShowTypes, sportsWithSelectionsTO, languageCulture, dateFormat);
          // let i = 0;
          // const eventsList: EventVM[] = [];
          // const sportIds: number[] = [];
          // for (const sportWithSelectionsTO of sportsWithSelectionsTO) {
          //   i++;
          //   const sport = this.modelMapper.mapSport(sportWithSelectionsTO, i);
          //   sportIds.push(sport.id);
          //   this.sports[sport.id] = sport;

          //   this.betTypeSelectionsForSport[sport.id] = sportWithSelectionsTO.selections.map((betTypeSelection) => this.modelMapper.mapBetTypeSelection(betTypeSelection));
          //   // await.betTypeSelectionsForSport[sport.id].map((s) => s.betTypeOutcomes = this.settingsService.getBetTypeOutcomesForSelection(s));

          //   for (const bts of this.betTypeSelectionsForSport[sport.id]) {
          //     bts.betTypeOutcomes = await this.settingsService.getBetTypeOutcomesForSelection(bts);
          //   }

          //   this.regions[sport.id] = {};
          //   let j = 0;
          //   for (const regionTO of sportWithSelectionsTO.regions) {
          //     j++;
          //     const region = this.modelMapper.mapRegion(regionTO, sport.name, i * 100 + j);
          //     this.regions[region.sportId][region.id] = region;
          //     this.competitions[region.id] = {};

          //     let k = 0;
          //     for (const competitionTO of regionTO.competitions) {
          //       k++;

          //       const competition = this.modelMapper.mapCompetition(competitionTO, sport.name, region.name, region.orderNo * 100 + k);
          //       this.competitions[region.id][competitionTO.id] = competition;

          //       for (const eventTO of competitionTO.events) {
          //         if (!this.events[eventTO.competitionId]) {
          //           this.events[eventTO.competitionId] = {};
          //         }
          //         const event = this.modelMapper.mapEvent(eventTO, sport.name, region.name, competition.name, languageCulture, dateFormat, false, this.userEventsForNotifications.includes(eventTO.id));
          //         this.events[event.competitionId][event.id] = event;

          //         eventsList.push(event);
          //         this.mapAndAddBetsToCacheAndGetPlayableCount(eventTO.bets, false, betTypeShowTypes, event);
          //       }
          //     }
          //   }
          // }

          // this.getLiveResultsForEventsAndAddToEvents(eventsList.map(ev => ev.id));
          // if (eventsList.length > 0) {
          //   this.eventsProvider.checkForVideoStream(eventsList.map(ev => ev.betRadarEventId)).subscribe((response) => {
          //     for (const resp of response) {
          //       const ev = eventsList.find(eventList => eventList.betRadarEventId === resp.betradarEventId);
          //       if (ev) {
          //         ev.liveStreamId = resp.streamId;
          //       }
          //     }
          //   });

          // }
          if (sportId === null) {
            // added because wee want to track also events from sports that are not on ui
            // this.cacheChangesService.addSportsSubscribtion(sportIds, this.isLive);
            this.cacheChangesService.subscribeForAllChangesLive();
          }
          return this.getSports(sportId);
        })
      );
    } else {
      return of(this.getSports(sportId));
    }
  }

  public getLiveEventsSelectionsAndSportOrdering(languageCulture: string, dateFormat: Intl.DateTimeFormatOptions): Observable<{ events: { [id: number]: EventVM }; selectionsDictionary: { [hierarchyId: number]: IBetTypeSelection[] }; sportOrdering: number[] }> {
    if (Object.keys(this.sports).length < 1) {
      this.clearSportsData();
      this.clearEventsData();
      const betTypeShowTypesResp = this.settingsService.getBetTypeShowTypes();
      const liveSportsResp = this.sportsProvider.getLiveSports(null);

      return forkJoin([betTypeShowTypesResp, liveSportsResp]).pipe(
        switchMap(async (responses) => {
          const betTypeShowTypes = responses[0];
          const sportsWithSelectionsTO = responses[1];
          await this.mapLiveSportsAndEventsAndAddToCache(betTypeShowTypes, sportsWithSelectionsTO, languageCulture, dateFormat);
          this.cacheChangesService.subscribeForAllChangesLive();
          return this.mapLiveEventsSelectionsAndSportOrderings();
        })
      );
    } else {
      return of(this.mapLiveEventsSelectionsAndSportOrderings());
    }
  }

  private mapLiveEventsSelectionsAndSportOrderings(): { events: { [id: number]: EventVM }; selectionsDictionary: { [hierarchyId: number]: IBetTypeSelection[] }; sportOrdering: number[] } {
    const sportOrdering: number[] = [];
    const events: { [id: number]: EventVM } = {};
    const selectionsDictionary: { [hierarchyId: number]: IBetTypeSelection[] } = {};
    const sports: ISport[] = this.utilityService.sortByOrderNo(Object.entries(this.sports).map(([k, v]) => v));

    for (const sport of sports) {
      sportOrdering.push(sport.id);
      if (this.betTypeSelectionsForSport[sport.id]) {
        selectionsDictionary[sport.id] = this.betTypeSelectionsForSport[sport.id];
      }
    }

    const regionIds = Object.keys(this.events).map(v => +v);
    for (const regionId of regionIds) {
      const eventIds = Object.keys(this.events[regionId]).map(v => +v);
      for (const eventId of eventIds) {
        events[eventId] = this.events[regionId][eventId];
      }
    }
    return { events, selectionsDictionary, sportOrdering };
  }

  private async mapLiveSportsAndEventsAndAddToCache(betTypeShowTypes: { [betTypeId: number]: IBetTypeShowType }, sportsWithSelectionsTO: ISportForLiveTreeTO[], languageCulture: string, dateFormat: Intl.DateTimeFormatOptions) {
    let i = 0;
    this.favoriteEventsCount = 0;
    const eventsList: EventVM[] = [];
    const sportIds: number[] = [];
    for (const sportWithSelectionsTO of sportsWithSelectionsTO) {
      i++;
      const sport = this.modelMapper.mapSportForLiveTree(sportWithSelectionsTO, i);
      sportIds.push(sport.id);
      this.sports[sport.id] = sport;

      this.betTypeSelectionsForSport[sport.id] = sportWithSelectionsTO.selections.map((betTypeSelection) => this.modelMapper.mapBetTypeSelection(betTypeSelection));
      // await this.betTypeSelectionsForSport[sport.id].map((s) => s.betTypeOutcomes = this.settingsService.getBetTypeOutcomesForSelection(s));

      for (const bts of this.betTypeSelectionsForSport[sport.id]) {
        const btosAndSvbDisplayType = await this.settingsService.getBetTypeOutcomesAndSbvDisplayTypeForSelection(bts);
        bts.betTypeOutcomes = btosAndSvbDisplayType.betTypeOutcomes;
        bts.sbvDispalyType = btosAndSvbDisplayType.sbvDisplayType;
      }

      this.regions[sport.id] = {};
      let j = 0;
      for (const regionTO of sportWithSelectionsTO.regions) {
        j++;
        const region = this.modelMapper.mapWebRegion(regionTO, sport.name, i * 100 + j);
        this.regions[region.sportId][region.id] = region;
        this.competitions[region.id] = {};

        let k = 0;
        for (const competitionTO of regionTO.competitions) {
          k++;

          const competition = this.modelMapper.mapWebCompetition(competitionTO, sport.name, region.name, region.orderNo * 100 + k, sport.id);
          this.competitions[region.id][competition.id] = competition;

          for (const eventTO of competitionTO.events) {
            if (!this.events[eventTO.competitionId]) {
              this.events[eventTO.competitionId] = {};
            }
            const event = this.modelMapper.mapEventFromV2(
              eventTO,
              languageCulture,
              this.utilityService.eventsDateToStringFormat,
              this.userEventsForNotifications.includes(eventTO.id),
              sport.name,
              region.name,
              competition.name);
            this.events[event.competitionId][event.id] = event;

            if (this.isEventInFavorites(event.id)) {
              this.events[event.competitionId][event.id].isInFavorite = true;
              this.favoriteEventsCount++;
            }

            eventsList.push(event);
            this.mapAndAddBetsToCacheAndGetPlayableCount(eventTO.bets, false, betTypeShowTypes, event);
          }
        }
      }
    }

    if (this.sports[-99]) {
      this.sports[-99].eventsCount = this.favoriteEventsCount;
    }

    this.getLiveResultsForEventsAndAddToEvents(eventsList.map(ev => ev.id));
    if (eventsList.length > 0) {
      this.eventsProvider.checkForVideoStream(eventsList.map(ev => ev.betRadarEventId)).subscribe((response) => {
        for (const resp of response) {
          const ev = eventsList.find(eventList => eventList.betRadarEventId === resp.betradarEventId);
          if (ev) {
            ev.liveStreamId = resp.streamId;
          }
        }
      });

    }
  }

  isEventInFavorites(eventId: number): boolean {
    if (this.favoriteLiveEventsSrc.find(ev => ev.eventId === eventId)) {
      return true;
    }
    return false;
  }

  private getLiveResultsForEventsAndAddToEvents(eventIds: number[]) {
    this.eventsProvider.getLiveResults(eventIds).subscribe((lriDic) => {
      const results: IEventLiveResultInfo[] = [];
      for (const eventId of eventIds) {
        const resultTO: IEventLiveResultInfoTO = lriDic[eventId.toString()];
        if (resultTO) {
          const result = this.modelMapper.mapEventLiveResult(lriDic[eventId]);
          if (this.events[result.competitionId] && this.events[result.competitionId][result.eventId]) {
            this.events[result.competitionId][result.eventId].result = result;
            results.push(result);
          }
        }
      }
    });
  }

  private getSports(sportId?: number): ISport[] {
    let sports: ISport[] = [];
    if (sportId) {
      if (this.sports[sportId]) {
        sports = [this.sports[sportId]];
      }
    } else {

      sports = Object.entries(this.sports).map(([k, v]) => v);
    }

    return this.sortByOrderNo(sports);
  }

  private async mapISportWithSelectionsWithFirstRegAndCmp(sportWithSelectionsTO: ISportForLiveTreeTO): Promise<ISportWithSelections> {
    const sportWithSelections = {
      sport: this.modelMapper.mapSportForLiveTree(sportWithSelectionsTO, 999),
      selections: sportWithSelectionsTO.selections.map(sel => this.modelMapper.mapBetTypeSelection(sel))
    };
    for (const bts of sportWithSelections.selections) {
      const btosAndSvbDisplayType = await this.settingsService.getBetTypeOutcomesAndSbvDisplayTypeForSelection(bts);
      bts.betTypeOutcomes = btosAndSvbDisplayType.betTypeOutcomes;
      bts.sbvDispalyType = btosAndSvbDisplayType.sbvDisplayType;
    }
    sportWithSelections.sport.regions = [this.modelMapper.mapWebRegion(sportWithSelectionsTO.regions[0], sportWithSelections.sport.name, 99999)];
    sportWithSelections.sport.regions[0].competitions = [this.modelMapper.mapWebCompetition(sportWithSelectionsTO.regions[0].competitions[0], sportWithSelections.sport.name, sportWithSelections.sport.regions[0].name, 9999999, sportWithSelectionsTO.id)];

    return sportWithSelections;
  }

  public searchForEvents(searchValue: string): EventVM[] {
    const events: EventVM[] = [];
    const competitionIds = Object.keys(this.events);
    for (const cmpKey of competitionIds) {
      const eventIds = Object.keys(this.events[+cmpKey]);
      for (const eventId of eventIds) {
        if (this.events[+cmpKey][+eventId].eventName.toLowerCase().includes(searchValue.toLowerCase())) {
          events.push(this.events[+cmpKey][+eventId]);
        }
      }
    }
    return this.utilityService.sortEventsByDateAndCode(events);
  }

  getBetAndOutcomes(eventId: number, betTypeId: number, betId: number): { bet: IBet; betOutcomes: { [betTypeOutcomeId: number]: IBetOutcome[] } } {
    const betAndOutcomes: { bet: IBet; betOutcomes: { [betTypeOutcomeId: number]: IBetOutcome[] } } = { bet: null, betOutcomes: {} };
    if (this.bets[eventId] && this.bets[eventId][betTypeId] && this.bets[eventId][betTypeId][betId]) {
      betAndOutcomes.bet = this.bets[eventId][betTypeId][betId];
    }
    if (this.betOutcomes[betId]) {
      for (const [k, bod] of Object.entries(this.betOutcomes[betId])) {
        betAndOutcomes.betOutcomes[k] = Object.entries(bod).map(([j, v]) => v);
      }
    }
    return betAndOutcomes;
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}

